/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable:max-line-length */
/* tslint:disable:cyclomatic-complexity */

import { ILoyaltySignUpViewProps } from '@msdyn365-commerce-modules/account-management/src/modules/loyalty-sign-up/./loyalty-sign-up';
import { ICheckoutState } from '@msdyn365-commerce/global-state';
import {
    issueLoyalty,
    IssueLoyaltyInput,
    updateCustomerAttributes,
    updateCustomerAttributesInput
} from '@msdyn365-commerce-modules/retail-actions';
// import { Button, Module, Node, Waiting } from '@msdyn365-commerce-modules/utilities';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { Button, Waiting } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    Address,
    AttributeDefinition,
    CustomerAttribute,
    DeliveryPreferenceType,
    LineDeliverySpecification,
    LoyaltyGroup,
    CardPaymentAcceptResult
} from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
// import MaskInput from 'react-maskinput';
import {
    // IHeadingData,
    ILoyaltySignUpProps,
    ILoyaltySignUpResources,
    // ISimpleMarketingConsentAttributesData,
    // ITermsAndConditionsLinkData
} from '../definition-extensions/loyalty-sign-up.ext.props.autogenerated';
import { ILoyaltySignUpData } from './loyalty-sign-up.data';
import { getCartState, ICartState, getCheckoutState } from '@msdyn365-commerce/global-state';
import { getSelectedVariant, SelectedVariantInput } from '@msdyn365-commerce-modules/retail-actions';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { TierType } from '../../../modules/dobbies-add-product-to-cart/components/add-product-to-cart';
// import PlaceOrderButtonComponent from '../../../modules/dobbiesclub-checkout/components/place-order-button';
import placeOrder from '../../../modules/dobbiesclub-checkout/methods/place-order';
import { getByIdAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { updateLineDeliverySpecificationsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import handleMask from '../utilities/input-mask-utility';
interface ISelectedProduct extends SimpleProduct {
    productVariant?: SimpleProduct;
}


const LoyaltySignUpView: React.FC<ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>> = props => {
    const {
        // LoyaltySignUp,
        // config: { termsAndConditionsLink },
        loading,
        slots: { dateOfBirthText }
    } = props;
    if (loading) {
        props.context.telemetry.error(props.resources.moduleWontRenderErrorText);
        return null;
    }
    const attributeDefinition: AttributeDefinition[] = (props.data.attributeDefinitions && props.data.attributeDefinitions.result) || [];
    // const [mask, setMask] = useState('DD/MM/YYYY');
    // const [maskString, setMaskString] = useState('DD/MM/YYYY');
    const [dateOfBirth, setdateOfBirth] = useState(Object);
    const [localStore, setLocalStore] = useState(Object);
    const [title, setTitle] = useState(Object);
    const [gender, setGender] = useState(Object);
    const [mobileNumber, setMobileNumber] = useState(Object);
    const [promoCode, setPromoCode] = useState('');
    const [isEmailChecked, setIsEmailChecked] = useState(Object);
    const [isPostChecked, setIsPostChecked] = useState(Object);
    const [isResearchChecked, setIsResearchChecked] = useState(Object);
    const [isSmsChecked, setIsSmsChecked] = useState(Object);
    const [isProfilingChecked, setIsProfilingChecked] = useState(Object);
    const [day, setDay] = useState(Object);
    const [month, setMonth] = useState(Object);
    const [year, setYear] = useState(Object);
    const [disabled, setDisabled] = useState(true);
    const [error, SetError] = useState('');
    const [displayNotification, SetDisplayNotification] = useState(false);
    const [overEighteen, SetOverEighteen] = useState(true);
    const [isValidDob, SetIsValidDob] = useState(false);
    const [isYearOutOfRange, setIsYearOutOfRange] = useState(false);
    const [minYear, SetMinYear] = useState(-1);
    const [maxYear, SetMaxYear] = useState(-1);
    const [dateError, SetDateError] = useState(''); // This state is used to display dob errors while adding dob
    const [isAddressError, setIsAddressError] = useState(false); // Will be true if there is no address
    const [addressError, setAddressError] = useState(''); // Error message for address
    const [currStep, setCurrStep] = useState(0);
    const [showBtnDisabled, setShowButtonDisabled] = useState(true);
    const [tAndRChecked, setTAndRChecked] = useState(false);
    const [currCartState, setCurrCartState] = useState<ICartState | undefined>(undefined);
    const [shouldBtnBeDisabled, setShouldBtnBeDisabled] = useState(true);

    const [isPaymentTriggered, setIsPaymentTriggered] = useState(false);
    // const [useBillingSameAsShipping, setUseBillingSameAsShipping] = useState(false);
    console.log(addressError);

    const { clubPremiumTierId, clubPlusTierId, clubPlusTrialTierId, clubPlusText, clubPlusBoltOnId } = props.config;
    // const clubPlusTierId = 5637327545;
    // const clubPremiumTierId = 5637677076;
    // const clubPlusTrialTierId = 5637626827;
    // const clubPlusText = 'club plus';

    const [inputCheck, setInputCheck] = useState([
        {
            Name: "Contactable Email",
            BooleanValue: false,
        },
        {
            Name:"Contactable Post",
            BooleanValue: false,
        },
        {
            Name:"Contactable Mobile",
            BooleanValue: false,
        }
    ]);

    console.log(inputCheck);

    const { loyaltyCard, customerInformation  } = props.data;
    const loyaltyGroup = loyaltyCard.result?.LoyaltyGroups && loyaltyCard.result?.LoyaltyGroups[0];
    const query = props.context.request.query;
    const dobbiesClubSiteUrl = props.context.request.app.config.dobbiesClubSiteUrl;
    const patternAttribute = {
        pattern: `^\s*\(?(020[7,8]{1}\)?[ ]?[1-9]{1}[0-9{2}[ ]?[0-9]{4})|(0[1-8]{1}[0-9]{3}\)?[ ]?[1-9]{1}[0-9]{2}[ ]?[0-9]{3})\s*$`
    };
    
    const updateDayMonthYearAttributes = (dob: string) => {
        const [D, M, Y] = dob.split('/');
        setDay(setAttributeValue(D, day, false));
        setMonth(setAttributeValue(M, month, false));
        setYear(setAttributeValue(Y, year, false));
    };

    if (!props.context.request.user.isAuthenticated) {
        const signinLink = props.context.request.user.signInUrl;
        window.location.assign(signinLink!);
    }
    
    useEffect(() => {
        if (props.data.inputsValidations.result?.areAllFieldsValid && !disabled && currStep > 0) {
            setDisabled(true);
        } else if (!props.data.inputsValidations.result?.areAllFieldsValid && disabled && currStep > 0) {
            setDisabled(false);
        }

    }, [props.data.inputsValidations.result?.areAllFieldsValid])

    useEffect(() => {
        const incomingMarketingAttributes = customerInformation.result?.Attributes;
        if(incomingMarketingAttributes!.length > 0){
            incomingMarketingAttributes?.map(attr => {
                if (attr.Name === "Contactable Post") {
                    setIsPostChecked(setAttributeValue(attr.AttributeValue?.BooleanValue!, attr, true));
                    setInputCheck(prevData => 
                        prevData.map(item => 
                            item.Name === attr.Name ? { ...item, BooleanValue: attr.AttributeValue?.BooleanValue! } : item
                    ));
                }
                if (attr.Name === "Contactable Email") {
                    setIsEmailChecked(setAttributeValue(attr.AttributeValue?.BooleanValue!, attr, true));
                    setInputCheck(prevData => 
                        prevData.map(item => 
                            item.Name === attr.Name ? { ...item, BooleanValue: attr.AttributeValue?.BooleanValue! } : item
                    ));
                }
                if (attr.Name === "Contactable Mobile") {
                    setIsSmsChecked(setAttributeValue(attr.AttributeValue?.BooleanValue!, attr, true));
                    setInputCheck(prevData => 
                        prevData.map(item => 
                            item.Name === attr.Name ? { ...item, BooleanValue: attr.AttributeValue?.BooleanValue! } : item
                    ));
                }
            })
        }
        const promoCodeCurrVal = getPromoCodeAttrCurrValue() || '';
        setPromoCode(promoCodeCurrVal);

        setTimeout(() => {
            let btn = document.getElementById('loyalty-next-btn') as HTMLButtonElement;
            if (!btn) {
                const btnElems = document.getElementsByClassName('loyalty-btn');
                if (btnElems && btnElems.length) {
                    btn = btnElems[0] as HTMLButtonElement;
                }
            }
            if (btn && !shouldBtnBeDisabled && btn.disabled) {
                btn.disabled = false;
                btn.classList.remove('disabled');
            }
        }, 1000);
        const isBackAfterPayment = props.context.actionContext.requestContext.cookies.get('is_payment_triggered');
        if (isBackAfterPayment && isBackAfterPayment.value === 'true') {
            placeLoyaltyOrderAfterPaymentTriggered();
        }
        if (props.context.request.query?.tier) {
            props.context.actionContext.requestContext.cookies.set('curr_checkout_tier', props.context.request.query?.tier);
        }
        props.context.actionContext.requestContext.cookies.set('step_1_clicked_next', 'false');
    }, [])

    const getTier = (props: ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>) => {
        const loyaltyGroup = props.data.loyaltyCard.result?.LoyaltyGroups && props.data.loyaltyCard.result?.LoyaltyGroups[0];
        // highestLoyaltCardTier
        const highestActiveLoyaltyCardTier = loyaltyGroup && loyaltyGroup.HighestActiveLoyaltyCardTier;
        const loyaltyCardTiers = loyaltyGroup && loyaltyGroup.LoyaltyCardTiers;
        // Get TierId based on the active cardTier
        if (loyaltyCardTiers && loyaltyCardTiers?.length > 0) {
            for (const [_, loyaltyCardTier] of loyaltyCardTiers.entries()) {
                if (loyaltyCardTier.RecordId === highestActiveLoyaltyCardTier) {
                    return loyaltyCardTier;
                }
            }
        }
        return;
    };
    const allowed_tiers: string[] = [TierType.Club, TierType.ClubPlus, TierType.ClubPlusFreeTrial, TierType.ClubPremium];
    if (query && query.tier && !allowed_tiers.includes(query.tier?.toLowerCase())) {
        window.location.assign('/loyalty');
    }

    const tier = getTier(props);

    if (tier && tier.TierId?.toLowerCase() === 'club' && query && query.tier && query.tier.toLowerCase() === 'club') {
        window.location.assign('/loyalty');
    }

    // TODO: Add Club Plus Validation

    if (tier && tier.TierId !== 'Club') {
        // Redirect to club-plus,  if user has membership of club plus or club plus free trial
        const today = new Date();
        const validTill = new Date(props.data.loyaltyCard.result?.LoyaltyGroups![0].LoyaltyCardTiers![0].ValidFrom!);
        const expiryDate = new Date(today);
        const validNumberOfDays: number = props.app.config.CheckValidityForTheNumberOfDays;
        expiryDate.setDate(expiryDate.getDate() + validNumberOfDays);

        // To calculate the time difference of two dates
        const differenceInTime = expiryDate.getTime() - validTill.getTime();

        // To calculate the no. of days between two dates
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        console.log('diff', differenceInDays, differenceInDays <= 0);

        if (
            query &&
            query.tier &&
            query.tier.toLowerCase() === 'club-plus-trial' &&
            tier &&
            (tier.TierId === 'Club Plus' || tier.TierId === 'Club Plus Free Tier')
        ) {
            window.location.assign(`${dobbiesClubSiteUrl}?tier=club-plus`);
        }
    }

    // UseEffect hook to set minyear and maxYear into state (useState hooks)
    setMinAndMaxYear(props, SetMinYear, minYear, SetMaxYear, maxYear);
    // Custom hook to get the customer address count.
    const addressCount = useGetAddressesCount(props);
    useEffect(() => {
        if (addressCount === undefined || addressCount?.length === 0) {
            setIsAddressError(true);
        } else {
            setIsAddressError(false);
            setAddressError('');
        }
    });

    // Get TierId based on the active cardTier Here's the tier ID could be (club, club plus)
    const tierId = getTierId(loyaltyGroup);
    /* VSI-Customization -- Redirect user based on tier conditions  */
    redirectUserIfTierExist(props, tierId);

    // const loyaltyProgramText =
    //     termsAndConditionsLink &&
    //     _renderTermsAndConditionsText(
    //         termsAndConditionsLink,
    //         props.resources.loyaltyProgramText,
    //         '__term-and-conditions-link',
    //         '__terms-and-conditions-text'
    //     );
    const { dynamicClass } = getDynamicClass(query, props);


    const validateDOB = (dob: string): boolean => {
        if (moment(dob, 'DD/MM/YYYY').format('DD/MM/YYYY') !== 'Invalid date') {
            const inputDob = moment(dob, 'DD/MM/YYYY', true);
            const isValidInput = inputDob.isValid();
            const inputDate = moment(dob, 'DD/MM/YYYY').format('DD/MM/YYYY');
            const today = new Date();
            const currentYear = today.getFullYear();
            const dobYear = moment(dob, 'DD/MM/YYYY').year();
            
            let isEighteenYearOld = true;
            let yearOOR = false;
            let futureDate = false;

            if (isValidInput) {
                const years = moment(inputDate, 'DD/MM/YYYY').fromNow(true); // Years difference from today
                if (inputDob < moment()) {
                    const diffYears = years.split(' ');
                    const yearLabel = diffYears[1].trim().toLowerCase();
                    if (yearLabel === 'year' || yearLabel === 'years') {
                        const _difference = diffYears[0].trim().toLowerCase();
                        const difference = parseInt(_difference, 10);
                        if ((dobYear < currentYear && _difference === 'a') || difference < 18) {
                            // Difference is 'a year' in case of 1 year and x months in case of some months
                            // SetOverEighteen(false);
                            // SetDisplayNotification(true);
                            // ageRestriction = true;
                            isEighteenYearOld = false;
                        } else if (dobYear < minYear) {
                            // dob must not be less than 1990
                            // SetDisplayNotification(true);
                            // setIsYearOutOfRange(true);
                            // invalidYear = true;
                            yearOOR = true;
                        } else {
                            // SetOverEighteen(true);
                            // SetDisplayNotification(false);
                            // SetDateError(''); // Remove date error if any
                        }
                    } else if (dobYear < currentYear) {
                        // when dobyear is less and difference is just of months or days
                        // SetOverEighteen(false);
                        // SetDisplayNotification(true);
                        // setIsYearOutOfRange(false);
                    } else {
                        futureDate = true; // input date is greater than today
                    }
                } else {
                    futureDate = true; // input date is greater than today
                }
                if (isEighteenYearOld && !yearOOR && !futureDate) {
                    if (!isValidDob) {
                        SetIsValidDob(true);
                    }
                    return true;
                }
            } else {
                // date is not valid
                return false;
            }
        }
        return false;
    }

    // tslint:disable-next-line:no-any
    const updateDOB = (e: any): void => {
        const {
        //     resources: { validYearErrorText, ageRestrictionError, validDateErrorText }
        resources: { validYearErrorText }
        } = props;
        let isInvalid = false;
        let ageRestriction = false;
        let invalidYear = false;
        let futureDate = false; // If user enters dob greater than today
        const dob = e && e.target && e.target.value;
        if (parseInt(dob[6], 10) > 2) {
            // setMaskString('DD/MM/YY');
            // setMask('DD/MM/YY');
        } else {
            // setMaskString('DD/MM/YYYY');
            // setMask('DD/MM/YY');
        }
        if (moment(dob, 'DD/MM/YYYY').format('DD/MM/YYYY') !== 'Invalid date') {
            const inputDob = moment(dob, 'DD/MM/YYYY', true);
            const isValidInput = inputDob.isValid();
            const inputDate = moment(dob, 'DD/MM/YYYY').format('DD/MM/YYYY');
            const today = new Date();
            const currentYear = today.getFullYear();
            const dobYear = moment(dob, 'DD/MM/YYYY').year();
            if (isValidInput) {
                const years = moment(inputDate, 'DD/MM/YYYY').fromNow(true); // Years difference from today
                if (inputDob < moment()) {
                    // SetIsValidDob(true);
                    const diffYears = years.split(' ');
                    const yearLabel = diffYears[1].trim().toLowerCase();
                    if (yearLabel === 'year' || yearLabel === 'years') {
                        const _difference = diffYears[0].trim().toLowerCase();
                        const difference = parseInt(_difference, 10);
                        if ((dobYear < currentYear && _difference === 'a') || difference < 18) {
                            // Difference is 'a year' in case of 1 year and x months in case of some months
                            SetOverEighteen(false);
                            SetDisplayNotification(true);
                            ageRestriction = true;
                        } else if (dobYear < minYear) {
                            // dob must not be less than 1990
                            SetDisplayNotification(true);
                            setIsYearOutOfRange(true);
                            invalidYear = true;
                        } else {
                            SetOverEighteen(true);
                            SetDisplayNotification(false);
                            SetDateError(''); // Remove date error if any
                        }
                    } else if (dobYear < currentYear) {
                        // when dobyear is less and difference is just of months or days
                        SetOverEighteen(false);
                        SetDisplayNotification(true);
                        setIsYearOutOfRange(false);
                        ageRestriction = true;
                    } else {
                        futureDate = true; // input date is greater than today
                    }
                } else {
                    futureDate = true; // input date is greater than today
                }
            } else {
                // date is not valid
                isInvalid = true;
            }
            // SetError('');
            // setdateOfBirth(setAttributeValue(moment(dob, 'DD/MM/YYYY').format('DD/MM/YYYY'), dateOfBirth, false));
            // setdateOfBirth(setAttributeValue(dob, dateOfBirth, false));
            updateDayMonthYearAttributes(moment(dob, 'DD/MM/YYYY').format('DD/MM/YYYY'));
        } else {
            // setdateOfBirth((prevState: CustomerAttribute) => ({
            //     ...prevState,
            //     AttributeValue: {
            //         // @ts-ignore
            //         '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CommercePropertyValue',
            //         StringValue: ''
            //     }
            // }));
            isInvalid = true; // date is not valid
        }
        if (isInvalid) {
            // SetDateError(validDateErrorText);
            SetIsValidDob(false);
            setIsYearOutOfRange(false);
            // SetDisplayNotification(true);
        } else if (futureDate) {
            // SetIsValidDob(true);
            // setIsYearOutOfRange(true);
        }
        let invalidDate = false; // Following code is to check date erorr while entering dob
        if (ageRestriction) {
            // SetError(ageRestrictionError);
            invalidDate = true;
        } else if (invalidYear || futureDate) {
            // SetError(validYearErrorText);
            invalidDate = true;
        }
        if (invalidDate) {
            SetDateError(validYearErrorText);
        }
        setdateOfBirth(setAttributeValue(dob, dateOfBirth, false));
    };

    const setAttributeDefaultValues = () => {
        const {
            genderAttribute,
            titleAttribute,
            contactableEmailAttribute,
            contactableMobileAttribute,
            contactablePostAttribute,
            mobileAttribute
        } = props.config;
        const {
            contactableProfilingAttribute,
            contactableResearchAttribute,
            dayAttribute,
            monthAttribute,
            yearAttribute,
            localStoreAttribute
        } = props.config;
        // tslint:disable-next-line: cyclomatic-complexity
        let isDayLoaded = false;
        let isMonthLoaded = false;
        let isYearLoaded = false;
        let dayStr = '';
        let monthStr = '';
        let yearStr = '';
        attributeDefinition?.forEach(attr => {
            const Name = attr.Name?.toLowerCase();
            if (Name === localStoreAttribute.toLowerCase() && Object.keys(localStore).length === 0) {
                setLocalStore(setAttrDefaultValues(attr));
            }
            if (Name === genderAttribute.toLowerCase() && Object.keys(gender).length === 0) {
                setGender(setAttrDefaultValues(attr));
            }
            if (Name === titleAttribute.toLowerCase() && Object.keys(title).length === 0) {
                const customer = props.data.customerInformation.result;
                const customerTitleAttr = titleAttribute && 
                customer?.Attributes?.find(attr => attr.Name?.toLowerCase() === titleAttribute.toLowerCase());
                if (customerTitleAttr && customerTitleAttr.AttributeValue?.StringValue) {
                    setTitle(setAttributeValue(customerTitleAttr.AttributeValue?.StringValue, attr, false));
                } else {
                    setTitle(setAttrDefaultValues(attr));
                }
            }
            if (Name === contactableEmailAttribute.toLowerCase() && Object.keys(isEmailChecked).length === 0) {
                setIsEmailChecked(setAttrDefaultValues(attr));
            }
            if (Name === contactablePostAttribute.toLowerCase() && Object.keys(isPostChecked).length === 0) {
                setIsPostChecked(setAttrDefaultValues(attr));
            }
            if (Name === contactableMobileAttribute.toLowerCase() && Object.keys(isSmsChecked).length === 0) {
                setIsSmsChecked(setAttrDefaultValues(attr));
            }
            if (Name === contactableResearchAttribute.toLowerCase() && Object.keys(isResearchChecked).length === 0) {
                setIsResearchChecked(setAttrDefaultValues(attr));
            }
            if (Name === contactableProfilingAttribute.toLowerCase() && Object.keys(isProfilingChecked).length === 0) {
                setIsProfilingChecked(setAttrDefaultValues(attr));
            }
            if (Name === mobileAttribute.toLowerCase() && Object.keys(mobileNumber).length === 0) {
                const customer = props.data.customerInformation.result;
                const customerMobileAttr = mobileAttribute && 
                customer?.Attributes?.find(attr => attr.Name?.toLowerCase() === mobileAttribute.toLowerCase());
                if (customerMobileAttr && customerMobileAttr.AttributeValue?.StringValue) {
                    setMobileNumber(setAttributeValue(customerMobileAttr.AttributeValue?.StringValue, attr, false));
                } else {
                    setMobileNumber(setAttrDefaultValues(attr));
                }
            }
            
            if (Name === dayAttribute.toLowerCase() && Object.keys(day).length === 0) {
                const customer = props.data.customerInformation.result;
                const customerDay = dayAttribute && 
                customer?.Attributes?.find(attr => attr.Name?.toLowerCase() === dayAttribute.toLowerCase());
                if (customerDay && customerDay.AttributeValue?.StringValue) {
                    setDay(setAttributeValue(customerDay.AttributeValue?.StringValue, attr, false));
                    isDayLoaded = true;
                    dayStr = customerDay.AttributeValue?.StringValue;
                } else {
                    setDay(setAttrDefaultValues(attr));
                }
            }
            if (Name === monthAttribute.toLowerCase() && Object.keys(month).length === 0) {
                const customer = props.data.customerInformation.result;
                const customerMonth = monthAttribute && 
                customer?.Attributes?.find(attr => attr.Name?.toLowerCase() === monthAttribute.toLowerCase());
                if (customerMonth && customerMonth.AttributeValue?.StringValue) {
                    setMonth(setAttributeValue(customerMonth.AttributeValue?.StringValue, attr, false));
                    isMonthLoaded = true;
                    monthStr = customerMonth.AttributeValue?.StringValue;
                } else {
                    setMonth(setAttrDefaultValues(attr));
                }
            }
            if (Name === yearAttribute.toLowerCase() && Object.keys(year).length === 0) {
                const customer = props.data.customerInformation.result;
                const customerYear = yearAttribute && 
                customer?.Attributes?.find(attr => attr.Name?.toLowerCase() === yearAttribute.toLowerCase());
                if (customerYear && customerYear.AttributeValue?.StringValue) {
                    setYear(setAttributeValue(customerYear.AttributeValue?.StringValue, attr, false));
                    isYearLoaded = true;
                    yearStr = customerYear.AttributeValue?.StringValue;
                } else {
                    setYear(setAttrDefaultValues(attr));
                }
            }

            if (Name?.toLowerCase() === localStoreAttribute.toLowerCase() && Object.keys(localStore).length === 0) {
                const customer = props.data.customerInformation.result;
                const localStoreSelected = localStoreAttribute && customer?.Attributes?.find(attr => attr.Name?.toLowerCase() === localStoreAttribute.toLowerCase());
                if (localStoreSelected && localStoreSelected.AttributeValue?.StringValue) {
                    setLocalStore(setAttributeValue(localStoreSelected.AttributeValue?.StringValue, attr, false));
                }

            }
        });
        if (isDayLoaded && isMonthLoaded && isYearLoaded) {
            SetIsValidDob(true);
            const dob = `${dayStr}/${monthStr}/${yearStr}`;
            setdateOfBirth(setAttributeValue(moment(dob, 'DD/MM/YYYY').format('DD/MM/YYYY'), dateOfBirth, false));
        } 
    };
    // Run at initial render and set the attribute values of customer
    setAttributeDefaultValues();

    const handleClubPlusScenario = async () => {
        // Check if address existed or not
        const isValid = validateAttributeValuesForClubPlus();
        if (isValid) {
            /* -3 If user is dobbies club free member and wants to enroll for club plus membership redirects him to checkout page */
            const {
                clubFreeTierText,
                directDebitAttribute: directDebitAttr,
                directDebitAttributeValue,
                promoCodeAttribute: promoCodeAttr
            } = props.config;
            if (
                (loyaltyCard.result?.CardNumber &&
                    tierId?.toLowerCase() === clubFreeTierText?.toLowerCase() &&
                    query?.tier?.toLowerCase() === 'club-plus') ||
                query?.tier?.toLowerCase() === 'club-plus-trial'
            ) {
                // update attribute Direct Debit
                const customer = props.data.customerInformation.result || { Attributes: [], AccountNumber: '' };
                const directDebitAttribute = getCustomAttribute(props, directDebitAttr, directDebitAttributeValue);
                const promoCodeAttribute = getCustomAttribute(props, promoCodeAttr, promoCode);
                // If user previously entered empty promo code filter the array and add newly promo code attribute with udpated value.
                const filteredAttributes = customer.Attributes?.filter(x => x.Name?.toLowerCase() !== promoCodeAttr.toLowerCase());
                if (customer && directDebitAttribute && filteredAttributes) {
                    filteredAttributes.push(directDebitAttribute);
                    filteredAttributes.push(promoCodeAttribute);
                }
                const input = new updateCustomerAttributesInput(
                    customer.AccountNumber,
                    filteredAttributes || [],
                    props.context.request.apiSettings
                );
                updateCustomerAttributes(input, props.context.actionContext).then(async () => {
                    if (query && query.tier && query.tier.toLowerCase() === 'club-plus-trial') {
                        // window.location.assign(`${dobbiesClubSiteUrl}?tier=club-plus-trial`);
                        setCurrStep(2);
                        matchTiersAndAddProductToCart();
                        setTimeout(() => {
                            const promoCodeInputElement = document.getElementById('dobbies-loyalty-promocode');
                            promoCodeInputElement?.addEventListener('focusout', (event: FocusEvent) => {
                                updatePromoCodeAttr(event);
                            });
                        }, 1000);
                    } else {
                        // window.location.assign(`${dobbiesClubSiteUrl}?tier=club-plus`);
                        if (query && query.tier && (query.tier === TierType.ClubPlus || query.tier === TierType.ClubPremium || query.tier === TierType.ClubPlusFreeTrial)) {
                            setCurrStep(2);
                            matchTiersAndAddProductToCart();
                            setTimeout(() => {
                                const promoCodeInputElement = document.getElementById('dobbies-loyalty-promocode');
                                promoCodeInputElement?.addEventListener('focusout', (event: FocusEvent) => {
                                    updatePromoCodeAttr(event);
                                });
                            }, 1000);
                        }
                    }
                    return;
                });
            }
            // If cardNumber doesn't exist or Tier is expired it means user wants to enroll for membership
            if (!loyaltyCard.result?.CardNumber) {
                _issueLoyalty();
            }
        }
        return;
    };
    // validate attribute values and update state accordingly
    const validateAttributeValuesForClubPlus = () => {
        // const {
        //     resources: { addressRequiredError }
        // } = props;
        if (isAddressError) {
            // SetError(addressRequiredError);
            setAddressError(props.resources.addressRequiredError);
            setDisabled(false);
            return false;
        }
        return true;
    };
    // validate attribute values and update state accordingly
    const validateAttributeValues = () => {
        const {
            resources: {
                validDateErrorText,
                validYearErrorText,
                ageRestrictionError
            }
        } = props;
        const queryTier = props.context.request.query?.tier?.toLowerCase();
        const isClub = queryTier === 'club';
        if (!isClub && !isValidDob) {
            SetError(validDateErrorText);
            SetDisplayNotification(true);
            setDisabled(false);
            return;
        }
        if (!isClub && isYearOutOfRange) {
            SetError(validYearErrorText);
            setDisabled(false);
            return;
        }
        if (!isClub && ((dateOfBirth && dateOfBirth.AttributeValue.StringValue === '') || !isValidDob)) {
            SetError(validDateErrorText);
            setDisabled(false);
            return;
        }
        if (!isClub && !overEighteen) {
            SetError(ageRestrictionError);
            setDisabled(false);
            return;
        }
        // if (gender && gender.AttributeValue && gender.AttributeValue.StringValue === '') {
        //     SetError(validGenderErrorText);
        //     setDisabled(false);
        //     return;
        // }
        // If localStore default value is set to empty string then set it to default None
        if (localStore && localStore.AttributeValue && localStore.AttributeValue.StringValue === '') {
            localStore.AttributeValue.StringValue = 'None';
        }
        if (title && title.AttributeValue && title.AttributeValue.StringValue === '') {
            // SetError(titleErrorMessage);
            setDisabled(false);
            return;
        }
        if (isAddressError) {
            // SetError(addressRequiredError);
            setDisabled(false);
            return;
        }
        return true;
    };

    const iconOneClicked = () => {
        setCurrStep(0);
    };

    const iconTwoClicked = () => {
        const stepOneNextClickedCookie = props.context.actionContext.requestContext.cookies.get('step_1_clicked_next');
        if (stepOneNextClickedCookie && stepOneNextClickedCookie.value === 'true' && validateInputs()) {
            const phoneNum = mobileNumber.AttributeValue?.StringValue;
            props.context.actionContext.requestContext.cookies.set('loyalty_singup_phone', phoneNum);
            setTAndRChecked(false);
            setCurrStep(1);
        }
    };

    const iconThreeClicked = () => {
        if (disabled) {
            return;
        }
        if (!areAttributesNew()) {
            setCurrStep(2);
        }
    };

    const areAttributesNew = () => {
        const attributes = [];
            // attributes.push(gender);
        attributes.push(day);
        attributes.push(month);
        attributes.push(year);
        attributes.push(localStore);
        attributes.push(title);
        // attributes.push(isSmsChecked);
        // attributes.push(isResearchChecked);
        // attributes.push(isEmailChecked);
        // attributes.push(isPostChecked);
        // attributes.push(isProfilingChecked);
        attributes.push(mobileNumber);
        const customer = props.data.customerInformation.result;
        if (customer && customer.Attributes?.length) {
            for (const at of attributes) {
                const cAt = customer.Attributes?.find(a => a.Name === at.Name);
                if (cAt && cAt.AttributeValue?.StringValue !== at.AttributeValue?.StringValue) {
                    return true;
                }
            }   
        }
        return false;
    };

    // When user wants to enroll for loyalty membership below function will triggered
    const updateAttributes = async () => {
        // const CardNumber = props.data.loyaltyCard.result?.CardNumber;
        const {
            context,
            config: { promoCodeAttribute }
        } = props;
        if (!props.context.request.user.isAuthenticated) {
            return;
        }
        // If cardNumber doesn't exist then validate attributes
        // if (!CardNumber) {
            const isValid = validateAttributeValues();
            if (!isValid) {
                return;
            }
            setDisabled(true);
            const _customer = props.data.customerInformation.result || { Attributes: [], AccountNumber: '' };
            const attributes = [];
            // attributes.push(gender);
            if (day?.AttributeValue?.StringValue && month?.AttributeValue?.StringValue && year?.AttributeValue?.StringValue) {
                attributes.push(day);
                attributes.push(month);
                attributes.push(year);
            }
            attributes.push(localStore);
            attributes.push(title);
            attributes.push(isSmsChecked);
            attributes.push(isResearchChecked);
            attributes.push(isEmailChecked);
            attributes.push(isPostChecked);
            attributes.push(isProfilingChecked);
            attributes.push(mobileNumber);
            // If user doesn't have cardNumber and query param is 'club-plus' send the direct debit attribute
            if (
                context.request.query?.tier?.toLowerCase() === 'club-plus' ||
                context.request.query?.tier?.toLowerCase() === 'club-plus-trial'
            ) {
                attributes.push(getCustomAttribute(props, props.config.directDebitAttribute, props.config.directDebitAttributeValue));
                attributes.push(getCustomAttribute(props, promoCodeAttribute, promoCode));
            }
            if (_customer) {
                _customer.Attributes = attributes;
            }
            // If cardNumber doesn't exist it means we've to set attributes
            const input = new updateCustomerAttributesInput(
                _customer.AccountNumber,
                _customer.Attributes || [],
                context.request.apiSettings
            );
            updateCustomerAttributes(input, context.actionContext)
                .then(async () => {
                    const queryTier = props.context.request.query?.tier?.toLowerCase();
                    if (queryTier === 'club' || queryTier?.toLowerCase() === TierType.Club.toLowerCase()) {
                        if (props.context.request.user.isAuthenticated && !props.data.loyaltyCard.result?.CardNumber) {
                            const input = new IssueLoyaltyInput(props.context.request.apiSettings, props.context.request.user.customerAccountNumber);
                            issueLoyalty(input, props.context.actionContext).then(res => {
                                window.location.assign('/dobbiesclub/loyalty-club-join-confirmation');
                            }).catch (e => {

                            });
                        }
                        else {
                            window.location.assign('/dobbiesclub/loyalty-club-join-confirmation');
                        }
                        return;
                    }
                    // Here we need to add several checks
                    await handleClubPlusScenario();
                })
                .catch((err: Error) => {
                    setDisabled(false);
                });
        // } else {
        //     await handleClubPlusScenario();
        // }
    };

    const getPromoCodeAttrCurrValue = () => {
        const customer = props.data.customerInformation.result || { Attributes: [], AccountNumber: '' };
        let promoCodeAttribute = customer?.Attributes?.find(attr => attr.Name?.toLowerCase() === 'Promo Code'.toLowerCase());
        return promoCodeAttribute?.AttributeValue?.StringValue;
    };

    const updatePromoCodeAttr = (event: FocusEvent) => {
        const customer = props.data.customerInformation.result || { Attributes: [], AccountNumber: '' };
        if (!event.target) {
            return;
        }
        const targetElem = event.target as HTMLInputElement;
        
        let promoCodeAttribute = customer?.Attributes?.find(attr => attr.Name?.toLowerCase() === 'Promo Code'.toLowerCase());
        let filteredAttributes = customer?.Attributes;
        if (promoCodeAttribute && filteredAttributes && filteredAttributes.length) {
            for (let i = 0; i < filteredAttributes?.length; i++) {
                if (filteredAttributes[i].Name?.toLowerCase() === 'Promo Code'.toLowerCase()) {
                    filteredAttributes.splice(i, 1);
                    break;
                }
            }
            const promoCodeAttribute = getCustomAttribute(props, props.config.promoCodeAttribute, targetElem.value);
            filteredAttributes?.push(promoCodeAttribute);
        } else {
            const promoCodeAttribute = getCustomAttribute(props, props.config.promoCodeAttribute, targetElem.value);
            filteredAttributes?.push(promoCodeAttribute);
        }

        const input = new updateCustomerAttributesInput(
                        customer.AccountNumber,
                        filteredAttributes || [],
                        props.context.request.apiSettings
                    );
        if(targetElem.value) {
            updateCustomerAttributes(input, props.context.actionContext).then(async resp => {
                console.log(resp);
            }).catch(e => {
                console.log(e);
            });
        }
    };

    const canPlaceOrder = async () => {

        const checkoutState = await getCheckoutState(props.context.actionContext);
        
        const shouldEnableSinglePaymentAuthorizationCheckout =
        checkoutState.shouldEnableSinglePaymentAuthorizationCheckout ?? false;

        // If isTermsAndConditionAccepted is undefined means TermsAndCondition module is not added to page and we should able to place order.
        return (
            shouldEnableSinglePaymentAuthorizationCheckout &&
            (
                shouldEnableSinglePaymentAuthorizationCheckout ||
                (checkoutState.isPaymentVerificationRedirection ?? false))
        );
    };

    // useEffect(() => {
    const updateIsEnabledRedirection = async () => {
        const cpOrder = await canPlaceOrder();
        let checkoutState = await getCheckoutState(props.context.actionContext);
        if (checkoutState.shouldEnableSinglePaymentAuthorizationCheckout && cpOrder && checkoutState.isPaymentVerificationRedirection) {
            await checkoutState.updateIsPlaceOrderEnabledInRedirection({
                newIsPlaceOrderEnabledInRedirection: true
            });
            if (checkoutState.shouldEnableSinglePaymentAuthorizationCheckout && !checkoutState.redirectAdditionalContext &&
                (!checkoutState.isExpressCheckoutApplied ||
                    checkoutState.isPaymentVerificationRedirection)) {
                        placeLoyaltyOrderAfterPaymentTriggered();
            }
        }
    }
    updateIsEnabledRedirection();
        
    // });

    useEffect(() => {
        if (isPaymentTriggered) {
            setTimeout(() => {
                if (window.location.href.includes('tier=')) {
                    placeLoyaltyOrderAfterPaymentTriggered();
                }
            }, 1000);
        }
    }, [isPaymentTriggered]);

    const triggerPaymentWithPlaceOrder = async (): Promise<void> => {
        const checkoutState = await getCheckoutState(props.context.actionContext);
        
        await checkoutState.updateShouldTriggerPaymentWithPlaceOrder({
            newShouldTriggerPaymentWithPlaceOrder: !checkoutState.shouldTriggerPaymentWithPlaceOrder
        });
        props.context.actionContext.requestContext.cookies.set('is_payment_triggered', 'true');
        setIsPaymentTriggered(true);
    };

    const _issueLoyalty = () => {
        if (props.context.request.user.isAuthenticated) {
            const input = new IssueLoyaltyInput(props.context.request.apiSettings, props.context.request.user.customerAccountNumber);
            issueLoyalty(input, props.context.actionContext)
                .then(async () => {
                    if (query && query.tier && query.tier.toLowerCase() === 'club-free') {
                        // window.location.assign(Msdyn365.getUrlSync('loyalty', props.context.actionContext) || '');
                        // setCurrStep(2);
                        // matchTiersAndAddProductToCart();
                    } else if (query && query.tier && query.tier.toLowerCase() === 'club-plus-trial') {
                        // window.location.assign(`${dobbiesClubSiteUrl}?tier=club-plus-trial`);
                        setCurrStep(2);
                        matchTiersAndAddProductToCart();
                        setTimeout(() => {
                            const promoCodeInputElement = document.getElementById('dobbies-loyalty-promocode');
                            promoCodeInputElement?.addEventListener('focusout', (event: FocusEvent) => {
                                updatePromoCodeAttr(event);
                            });
                        }, 1000);
                    } else {
                        // window.location.assign(`${dobbiesClubSiteUrl}?tier=club-plus`);
                        setCurrStep(2);
                        matchTiersAndAddProductToCart();
                        setTimeout(() => {
                            const promoCodeInputElement = document.getElementById('dobbies-loyalty-promocode');
                            promoCodeInputElement?.addEventListener('focusout', (event: FocusEvent) => {
                                updatePromoCodeAttr(event);
                            });
                        }, 1000);
                    }
                })
                .catch((err: Error) => {
                    props.telemetry.error(err.message);
                    props.telemetry.debug(props.resources.loyaltyCardIssue);
                    setDisabled(false);
                });
        }
    };

    const updateCustomerDDAttribute = async () => {
        
        const { context } = props;
        const customer = props.data.customerInformation.result!;
        const customerAttr = customer.Attributes;
        let boltonAttrSet = false;
        const newAttributes = customerAttr?.map(attr => {
            let attrValue = attr.AttributeValue;
            if (attr.Name === 'Direct Debit') {
                const value = attrValue?.StringValue === 'None' || attrValue?.StringValue === 'DDCAN' ? 'DDRP' : 'DDRP';

                attrValue = { ...attr.AttributeValue, StringValue: value };
            }
            if (props.context.request.query?.tier === 'club-plus-bolton') {
                if (attr.Name === 'IsBoltonMember') {
                    attrValue = { ...attr.AttributeValue, StringValue: 'Yes' };
                    boltonAttrSet = true;
                }
            }
            return { ...attr, AttributeValue: attrValue };
        });

        if (props.context.request.query?.tier === 'club-plus-bolton' && !boltonAttrSet) {
            if (newAttributes) {
                const defaultAttribute = props.data.attributeDefinitions.result?.find(
                    attr => attr.Name?.toLowerCase() === 'IsBoltonMember'.toLowerCase()
                );
                newAttributes.push({
                    ['AttributeValue']: {
                        // @ts-ignore
                        '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CommercePropertyValue',
                        StringValue: 'Yes'
                    },
                    ['@odata.type']: '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CustomerAttribute',
                    ['ExtensionProperties@odata.type']: '#Collection(Microsoft.Dynamics.Commerce.Runtime.DataModel.CommerceProperty)',
                    ['NameTranslations@odata.type']: '#Collection(Microsoft.Dynamics.Commerce.Runtime.DataModel.TextValueTranslation)',
                    ['NameTranslations']: [],
                    ['DataTypeValue']: defaultAttribute && defaultAttribute.DataTypeValue,
                    ['KeyName']: defaultAttribute && defaultAttribute.Name,
                    ['Name']: defaultAttribute && defaultAttribute.Name,
                    ['RecordId']: defaultAttribute && defaultAttribute.RecordId,
                    ['ExtensionProperties']: []
                });
            }
        }

        const input = new updateCustomerAttributesInput(customer.AccountNumber, newAttributes || [], context.request.apiSettings);
        try {
            await updateCustomerAttributes(input, context.actionContext).catch();
        } catch (error) {
            if (context.telemetry) {
                //@ts-ignore
                context.telemetry.exception(error);
                context.telemetry.debug('Unable to update customer attributes');
            }
        }
        if (props.context.request.query?.tier) {
            const urlTier = props.context.request.query?.tier.toLowerCase();
            if (urlTier && urlTier === 'club-plus') {
                props.context.request.cookies.set('club_plus_purchased', true, {
                    expires: new Date(new Date().getTime() + 1000 * 60 * 60)
                });
            }
        } else {
            const cookieTier = props.context.actionContext.requestContext.cookies.get('curr_checkout_tier');
            if (cookieTier && cookieTier.value && cookieTier.value === 'club-plus') {
                props.context.request.cookies.set('club_plus_purchased', true, {
                    expires: new Date(new Date().getTime() + 1000 * 60 * 60)
                });
            }
        }
        
    };

    const updateCartLineEmailAddress = async (newGuestCheckoutEmail: string, checkoutState: ICheckoutState): Promise<number | undefined> => {
        const emailDeliveryModeCode = props.context.request.channel?.EmailDeliveryModeCode;

        const emailDeliveryCartLines = checkoutState.checkoutCart.cart.CartLines?.filter(
            cartLine => cartLine.DeliveryMode && cartLine.DeliveryMode !== '' && cartLine.DeliveryMode === emailDeliveryModeCode
        );

        let updatedCartVersion: number | undefined;
        if (emailDeliveryCartLines && emailDeliveryCartLines.length > 0) {
            const lineDeliverySpecifications: LineDeliverySpecification[] = emailDeliveryCartLines.map(line => {
                return {
                    LineId: line.LineId,
                    DeliverySpecification: {
                        DeliveryModeId: emailDeliveryModeCode,
                        DeliveryPreferenceTypeValue: DeliveryPreferenceType.ElectronicDelivery,
                        ElectronicDeliveryEmailAddress: newGuestCheckoutEmail
                    }
                };
            });

            await updateLineDeliverySpecificationsAsync(
                { callerContext: props.context.actionContext },
                checkoutState.checkoutCart.cart.Id,
                lineDeliverySpecifications
            )
                .then(updatedCart => {
                    updatedCartVersion = updatedCart.Version;
                })
                .catch(error => {
                    props.context.actionContext.telemetry.exception(error);
                    throw new Error('[updateLineDeliverySpecificationsAsync] Unable to update electronic delivery email address in cart');
                });
        }

        return updatedCartVersion;
    };

    const getReturnUrl = (): string => {
        // let returnUrl = getUrlSync('checkout', this.props.context.actionContext) || '';
        let returnUrl = Msdyn365.getUrlSync('dobbiesclub-loyalty-join', props.context.actionContext) || '';
        const absoluteUrlRegExp = new RegExp('^(?:[a-z]+:)?//', 'i');
        const isAbsoluteUrl = absoluteUrlRegExp.test(returnUrl);
        if (window && !isAbsoluteUrl) {
            returnUrl = `${window.location.origin}${returnUrl}`;
        }

        return `${returnUrl}${!returnUrl.includes('?') ? '?' : '&'}pv=1`;
    };

    const placeLoyaltyOrderAfterPaymentTriggered = async () => {
        props.context.actionContext.requestContext.cookies.set('is_payment_triggered', 'false');
        const checkoutState = await getCheckoutState(props.context.actionContext);
        // if (props.data.customerInformation.result?.Email) {
        //     await checkoutState.checkoutCart.updateReceiptEmail({ newEmail: props.data.customerInformation.result?.Email });
        // }

        if (!checkoutState.cardPaymentAcceptResult && checkoutState.isPaymentVerificationRedirection && checkoutState.shouldEnableSinglePaymentAuthorizationCheckout) {
            const { requestFormData, query } = props.context.request;
            const settings = {
                ReturnUrl: getReturnUrl(),
                ...(props.config.paymentConnectorId && { PaymentConnectorId: props.config.paymentConnectorId })
            };
            const formData = btoa(JSON.stringify(requestFormData ?? { redirectResult: query?.redirectResult }));
            const cardPaymentAcceptResult: CardPaymentAcceptResult = {
                AccessCode: formData,
                Settings: settings
            };

            await checkoutState
                .updateCardPaymentAcceptResult({ newCardPaymentAcceptResult: cardPaymentAcceptResult })
        }
        
        if (checkoutState.checkoutCart.cart.CartLines && checkoutState.checkoutCart.cart.CartLines.length && checkoutState.checkoutCart.cart.CartLines[0].ProductId) {
            const response = await getByIdAsync({ callerContext: props.context.actionContext }, checkoutState.checkoutCart.cart.CartLines[0].ProductId, props.context.actionContext.requestContext.apiSettings.channelId);
            const simpleProduct = Array.isArray(response) ? response[0] : response;
            if (props.data.customerInformation.result?.Email) {
                await checkoutState.checkoutCart.updateReceiptEmail({ newEmail: props.data.customerInformation.result?.Email });
            }
            if (props.data.customerInformation.result?.Email) {
                await checkoutState.updateGuestCheckoutEmail({newGuestCheckoutEmail: props.data.customerInformation.result?.Email});
            }
            if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length) {
                await checkoutState.checkoutCart.updateShippingAddress({ newShippingAddress: props.data.customerInformation.result?.Addresses[0] });
            }
            if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length) {
                await checkoutState.updateShippingAddress({ newShippingAddress: props.data.customerInformation.result?.Addresses[0] });
            }
            const cl = checkoutState.checkoutCart.cart.CartLines.length && checkoutState.checkoutCart.cart.CartLines[0];
            if (checkoutState.checkoutCart.cart.DeliveryMode !== props.config.modeOfDeliveryId! || (cl && cl.DeliveryMode !== props.config.modeOfDeliveryId!)) {
                const updateCartDeliverySpecificationInput = {
                    deliveryModeId: props.config.modeOfDeliveryId!,
                    shippingAddress: props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length ? props.data.customerInformation.result?.Addresses[0] : false
                };
                await checkoutState.checkoutCart.updateCartDeliverySpecification(updateCartDeliverySpecificationInput).then(async response => {
                            if (response.status === 'FAILED') {
                                console.log('delivery options selection failed or doesnt exist.', response.errorDetails);
                            } else {
                                console.log('Delivery option call has been completed');
                                const updatedCartVersion = await updateCartLineEmailAddress(checkoutState.guestCheckoutEmail, checkoutState);
                                placeOrder(props.context.actionContext, checkoutState, [simpleProduct], false, updatedCartVersion, checkoutState.isPaymentVerificationRedirection, updateCustomerDDAttribute).then(async resp => {
                                    console.log('Placed loyalty order', resp);
                                    await updateCustomerDDAttribute();
                                    const transactionIdCookie = props.context.actionContext.requestContext.cookies.get('cp_sales_transaction_id')?.value || '';
                                    window.location.assign(`/dobbiesclub/clubplus-confirmation?transactionId=${transactionIdCookie}`);
                                }).catch(e => {
                                    console.log('Error placing loyalty order', e);
                                })
                            }
                        })
                        .catch(() => {
                            console.log(`Couldn't updated delivery options`);
                        });
                } else {
                    const updatedCartVersion = await updateCartLineEmailAddress(checkoutState.guestCheckoutEmail, checkoutState);
                    placeOrder(props.context.actionContext, checkoutState, [simpleProduct], false, updatedCartVersion, checkoutState.isPaymentVerificationRedirection, updateCustomerDDAttribute).then(async resp => {
                        console.log('Placed loyalty order', resp);
                        await updateCustomerDDAttribute();
                        const transactionIdCookie = props.context.actionContext.requestContext.cookies.get('cp_sales_transaction_id')?.value || '';
                        window.location.assign(`/dobbiesclub/clubplus-confirmation?transactionId=${transactionIdCookie}`);
                    }).catch(e => {
                        console.log('Error placing loyalty order', e);
                    })
                }
        }
        setIsPaymentTriggered(false);
    }

    const placeLoyaltyOrder = async () => {
        const checkoutState = await getCheckoutState(props.context.actionContext);
        // if (props.data.customerInformation.result?.Email) {
        //     await checkoutState.checkoutCart.updateReceiptEmail({ newEmail: props.data.customerInformation.result?.Email });
        // }
        

        if (checkoutState.checkoutCart.cart.CartLines && checkoutState.checkoutCart.cart.CartLines.length && checkoutState.checkoutCart.cart.CartLines[0].ProductId) {
            const response = await getByIdAsync({ callerContext: props.context.actionContext }, checkoutState.checkoutCart.cart.CartLines[0].ProductId, props.context.actionContext.requestContext.apiSettings.channelId);
            const simpleProduct = Array.isArray(response) ? response[0] : response;
            if (props.data.customerInformation.result?.Email) {
                await checkoutState.checkoutCart.updateReceiptEmail({ newEmail: props.data.customerInformation.result?.Email });
            }
            if (props.data.customerInformation.result?.Email) {
                await checkoutState.updateGuestCheckoutEmail({newGuestCheckoutEmail: props.data.customerInformation.result?.Email});
            }
            if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length) {
                await checkoutState.checkoutCart.updateShippingAddress({ newShippingAddress: props.data.customerInformation.result?.Addresses[0] });
            }
            if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length) {
                await checkoutState.updateShippingAddress({ newShippingAddress: props.data.customerInformation.result?.Addresses[0] });
            }
            // if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length) {
            //     if (useBillingSameAsShipping) {
            //         await checkoutState.updateBillingAddress({ newBillingAddress: props.data.customerInformation.result?.Addresses[0] });
            //     } else {
            //         if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length > 1) {
            //             await checkoutState.updateBillingAddress({ newBillingAddress: props.data.customerInformation.result?.Addresses[1] });
            //         }
            //     }
            // }
            const cl = checkoutState.checkoutCart.cart.CartLines.length && checkoutState.checkoutCart.cart.CartLines[0];
            if (checkoutState.checkoutCart.cart.DeliveryMode !== props.config.modeOfDeliveryId! || (cl && cl.DeliveryMode !== props.config.modeOfDeliveryId!)) {
                const updateCartDeliverySpecificationInput = {
                    deliveryModeId: props.config.modeOfDeliveryId!,
                    shippingAddress: props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length ? props.data.customerInformation.result?.Addresses[0] : false
                };
                await checkoutState.checkoutCart.updateCartDeliverySpecification(updateCartDeliverySpecificationInput).then(async response => {
                            if (response.status === 'FAILED') {
                                console.log('delivery options selection failed or doesnt exist.', response.errorDetails);
                            } else {
                                console.log('Delivery option call has been completed');
                                const updatedCartVersion = await updateCartLineEmailAddress(checkoutState.guestCheckoutEmail, checkoutState);
                                
                                // await placeOrder(
                                //     actionContext,
                                //     this.props.data.checkout.result,
                                //     this.props.data.products.result,
                                //     !hasOrderConfirmation,
                                //     updatedCartVersion,
                                //     this.props.data.checkout.result?.isPaymentVerificationRedirection,
                                //     this.updateCustomerDDAttribute
                                // )
                                
                                const shouldEnableSinglePaymentAuthorizationCheckout =
                                    checkoutState.shouldEnableSinglePaymentAuthorizationCheckout ?? false;
    
                                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Explicitly check null/undefined.
                                const isExpressCheckoutApplied = checkoutState.isExpressCheckoutApplied ?? false;
                                if (!isExpressCheckoutApplied && shouldEnableSinglePaymentAuthorizationCheckout) {
                                    triggerPaymentWithPlaceOrder();
                                } else {
                                    placeOrder(props.context.actionContext, checkoutState, [simpleProduct], false, updatedCartVersion, checkoutState.isPaymentVerificationRedirection, updateCustomerDDAttribute).then(async resp => {
                                        console.log('Placed loyalty order', resp);
                                        await updateCustomerDDAttribute();
                                        const transactionIdCookie = props.context.actionContext.requestContext.cookies.get('cp_sales_transaction_id')?.value || '';
                                        window.location.assign(`/dobbiesclub/clubplus-confirmation?transactionId=${transactionIdCookie}`);
                                    }).catch(e => {
                                        console.log('Error placing loyalty order', e);
                                    })
                                }
                            }
                        })
                        .catch(() => {
                            console.log(`Couldn't updated delivery options`);
                        });
            } else {
                const updatedCartVersion = await updateCartLineEmailAddress(checkoutState.guestCheckoutEmail, checkoutState);
                const shouldEnableSinglePaymentAuthorizationCheckout =
                    checkoutState.shouldEnableSinglePaymentAuthorizationCheckout ?? false;

                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Explicitly check null/undefined.
                const isExpressCheckoutApplied = checkoutState.isExpressCheckoutApplied ?? false;
                if (!isExpressCheckoutApplied && shouldEnableSinglePaymentAuthorizationCheckout) {
                    triggerPaymentWithPlaceOrder();
                } else {
                    placeOrder(props.context.actionContext, checkoutState, [simpleProduct], false, updatedCartVersion, checkoutState.isPaymentVerificationRedirection, updateCustomerDDAttribute).then(async resp => {
                        console.log('Placed loyalty order', resp);
                        await updateCustomerDDAttribute();
                        const transactionIdCookie = props.context.actionContext.requestContext.cookies.get('cp_sales_transaction_id')?.value || '';
                        window.location.assign(`/dobbiesclub/clubplus-confirmation?transactionId=${transactionIdCookie}`);
                    }).catch(e => {
                        console.log('Error placing loyalty order', e);
                    })
                }
            }


            
            
        }
        // else {
        //     const response = await getByIdAsync({ callerContext: props.context.actionContext }, 5637327545, props.context.actionContext.requestContext.apiSettings.channelId);
        //     const simpleProduct = Array.isArray(response) ? response[0] : response;
        //     if (props.data.customerInformation.result?.Email) {
        //         await checkoutState.checkoutCart.updateReceiptEmail({ newEmail: props.data.customerInformation.result?.Email });
        //     }
        //     if (props.data.customerInformation.result?.Email) {
        //         await checkoutState.updateGuestCheckoutEmail({newGuestCheckoutEmail: props.data.customerInformation.result?.Email});
        //     }
        //     if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length) {
        //         await checkoutState.checkoutCart.updateShippingAddress({ newShippingAddress: props.data.customerInformation.result?.Addresses[0] });
        //     }
        //     if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length) {
        //         await checkoutState.updateShippingAddress({ newShippingAddress: props.data.customerInformation.result?.Addresses[0] });
        //     }
        //     if (props.data.customerInformation.result?.Addresses && props.data.customerInformation.result?.Addresses.length) {
        //         await checkoutState.updateBillingAddress({ newBillingAddress: props.data.customerInformation.result?.Addresses[0] });
        //     }
        //     const updateCartDeliverySpecificationInput = {
        //         deliveryModeId: 'Nodel',
        //         shippingAddress: true
        //     };
        //     await checkoutState.checkoutCart.updateCartDeliverySpecification(updateCartDeliverySpecificationInput).then(response => {
        //         if (response.status === 'FAILED') {
        //             console.log('delivery options selection failed or doesnt exist.');
        //         } else {
        //             console.log('Delivery option call has been completed');
        //         }
        //     })
        //     .catch(() => {
        //         console.log(`Couldn't updated delivery options`);
        //     });
        //     placeOrder(props.context.actionContext, checkoutState, [simpleProduct], checkoutState.isPaymentVerificationRedirection, checkoutState.checkoutCart.cart.Version, checkoutState.isPaymentVerificationRedirection, updateCustomerDDAttribute)
        // }
    }

    // const updateGenderValue = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    //     const selectedGender = event.target.value;
    //     SetError('');
    //     setGender(setAttributeValue(selectedGender, gender, false));
    // };
    const updateLocalStore = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const selectedLocalStore = event.target.value;
        // SetError('');
        setLocalStore(setAttributeValue(selectedLocalStore, localStore, false));
    };
    const updateTitle = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const selectedTitle = event.target.value;
        // SetError('');
        setTitle(setAttributeValue(selectedTitle, title, false));
    };

    /** VSI Customization -- END */
    const renderDropDownOptionsForAttribute = (attribute: string) => {
        const attr = props.data.attributeDefinitions?.result?.find(x => x.AttributeTypeName?.toLowerCase() === attribute.toLowerCase());
        return attr?.EnumerationDetails?.map(e => {
            return (
                <option aria-selected='true' value={e.EnumerationValue} key={e.EnumerationValue}>
                    {e.EnumerationValue}
                </option>
            );
        });
    };
    // Render dropdown options for localstore attribute
    const renderLocalStores = () => {
        const { localStoreAttribute } = props.config;
        const localStoreAttr = props.data.attributeDefinitions?.result?.find(
            x => x.AttributeTypeName?.toLowerCase() === localStoreAttribute.toLowerCase()
        );
        const localStores = localStoreAttr?.EnumerationDetails?.sort((a, b) => a.EnumerationValue!.localeCompare(b.EnumerationValue!));
        // Move none value to the start of array
        const noneVal =
            localStores &&
            localStores.find(store => {
                return store.EnumerationValue && store.EnumerationValue.toLowerCase() === 'none';
            });
        localStores?.sort((x, y) => {
            return x.EnumerationValue === noneVal?.EnumerationValue ? -1 : y === noneVal?.EnumerationValue ? 1 : 0;
        });
        return localStores?.map(e => {
            if(e.EnumerationValue == noneVal?.EnumerationValue) {
                return (<option aria-selected='true' value=''>
                        {localStore && localStore.AttributeValue.StringValue ? localStore.AttributeValue.StringValue : 'Local Store *'}
                    </option>)
            }
            return (
                <option aria-selected='true' value={e.EnumerationValue} key={e.EnumerationValue}>
                    {e.EnumerationValue}
                </option>
            );
        });
    };

    /* VSI-Customization -- Update button attribute disabled (true or false) based on certain checkbox checked or not  */
    const handleTermsCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
        // update state (toggle) based on terms and conditions checkbox checked or not
        // setDisabled(!e.target.checked);
        setTAndRChecked(e.target.checked);
    };

    // const doNotUseSameBillingAddressAsShipping = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     // update state (toggle) based on terms and conditions checkbox checked or not
    //     setUseBillingSameAsShipping(false);
    //     checkOnlyOne(e.target);
    // };
    // const doUseSameBillingAddressAsShipping = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     // update state (toggle) based on terms and conditions checkbox checked or not
    //     const target = e.target;
    //     checkOnlyOne(target);
    //     getCheckoutState(props.context.actionContext).then(checkoutState => {
    //         if (props.data.customerInformation.result?.Addresses &&  props.data.customerInformation.result?.Addresses.length) {
    //             checkoutState.updateBillingAddress({ newBillingAddress: props.data.customerInformation.result?.Addresses[0]}).then(resp => {
    //                 setUseBillingSameAsShipping(true);
    //             });
    //         }
    //     }).catch(e => {
    //         uncheckCheckbox(target);
    //     });
    // };

    // const uncheckCheckbox = (checkbox: HTMLInputElement): void => {
    //     const checkboxes = document.getElementsByName(checkbox.name) as NodeListOf<HTMLInputElement>;
    //     checkboxes.forEach((item) => {
    //         if (item === checkbox) item.checked = false;
    //     });
    // };

    // const checkOnlyOne = (checkbox: HTMLInputElement): void => {
    //     const checkboxes = document.getElementsByName(checkbox.name) as NodeListOf<HTMLInputElement>;
    //     checkboxes.forEach((item) => {
    //         if (item !== checkbox) item.checked = false;
    //     });
    // };
    

    /* VSI Customization -- Check if gender is not selected, display error message */
    // const _genderNotSelectedErrorMsg = () => {
    //     const { validGenderErrorText } = props.resources;
    //     // Dont display error on adding dob input i.e. before clicking Next button
    //     if (dateError !== '') {
    //         return;
    //     }
    //     if (error !== '' && gender && gender.AttributeValue && gender.AttributeValue.StringValue === '') {
    //         return <Node className='gender-not-selected-error'>{validGenderErrorText}</Node>;
    //     }
    //     return;
    // };
    // /* VSI Customization -- Check if title is not selected, display error message */
    // const titleNotSelectedErrorMsg = () => {
    //     const { titleErrorMessage } = props.resources;
    //     // Dont display error on adding dob input i.e. before clicking Next button
    //     if (dateError !== '') {
    //         return;
    //     }
    //     if (error !== '' && title && title.AttributeValue && title.AttributeValue.StringValue === '') {
    //         return <Node className='localstore-not-selected-error'>{titleErrorMessage}</Node>;
    //     }
    //     return;
    // };
    // Render loyalty terms link
    const _renderLoyaltyTermsLink = () => {
        return (
            <p className='ms-loyalty-signup__terms'>
                {query?.tier === 'club' ? 'I have read and agree to the terms and conditions of Club' : 'I have read and agree to the terms and conditions of Club Plus'}
            </p>
        );
    };
    // event handler for mobile field
    const handleMobileNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setMobileNumber(setAttributeValue(value, mobileNumber, false));
    };
    // Event handler for marketing consent attributes
    // const handleMarketingConsent = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const {
    //         contactableEmailAttribute,
    //         contactableMobileAttribute,
    //         contactablePostAttribute,
    //         contactableProfilingAttribute,
    //         contactableResearchAttribute
    //     } = props.config;
    //     const targetName = event.target.name.toLowerCase();
    //     const isChecked = event.target.checked;
    //     if (targetName === contactablePostAttribute.toLowerCase()) {
    //         setIsPostChecked(setAttributeValue(isChecked, isPostChecked, true));
    //         setInputCheck(prevData => 
    //             prevData.map(item => 
    //                 item.Name.toLowerCase() === targetName ? { ...item, BooleanValue: isChecked } : item
    //         ));
    //     }
    //     if (targetName === contactableEmailAttribute.toLowerCase()) {
    //         setIsEmailChecked(setAttributeValue(isChecked, isEmailChecked, true));
    //         setInputCheck(prevData => 
    //             prevData.map(item => 
    //                 item.Name.toLowerCase() === targetName ? { ...item, BooleanValue: isChecked } : item
    //         ));
    //     }
    //     if (targetName === contactableResearchAttribute.toLowerCase()) {
    //         setIsResearchChecked(setAttributeValue(isChecked, isResearchChecked, true));
    //     }
    //     if (targetName === contactableMobileAttribute.toLowerCase()) {
    //         setIsSmsChecked(setAttributeValue(isChecked, isSmsChecked, true));
    //         setInputCheck(prevData => 
    //             prevData.map(item => 
    //                 item.Name.toLowerCase() === targetName ? { ...item, BooleanValue: isChecked } : item
    //         ));
    //     }
    //     if (targetName === contactableProfilingAttribute.toLowerCase()) {
    //         setIsProfilingChecked(setAttributeValue(isChecked, isProfilingChecked, true));
    //     }
    // };
    // Render Marketing consent attributes section
    // const renderMarketingConsentSection = () => {
    //     const cardNumber = props.data.loyaltyCard.result?.CardNumber;
    //     const {
    //         marketingPreferenceHeading,
    //         clubMarketingConsentDescription,
    //         clubPlusMarketingConsentDescription,
    //         updatePreferenceText
    //     } = props.resources;
    //     const { clubPlusMarketingConsentAttributes, simpleMarketingConsentAttributes } = props.config;
    //     if (!cardNumber) {
    //         return (
    //             <>
    //                 <div className='loyalty-signup-section contact-permission-section'>
    //                     <div>
    //                         <h2>{marketingPreferenceHeading}</h2>
    //                         <p>{clubMarketingConsentDescription}</p>
    //                         <div className='ms-loyalty-signup__marketing-consents'>
    //                             {/* Render club marketing consent attributes section */}
    //                             <div className='ms-loyalty-signup__marketing-consents--section'>
    //                                 {simpleMarketingConsentAttributes && renderMarketingConsentAttributes(simpleMarketingConsentAttributes)}
    //                             </div>
    //                             <p>{clubPlusMarketingConsentDescription}</p>
    //                             <div className='ms-loyalty-signup__marketing-consents'>
    //                                 {/* Render club plus marketing consent attributes section */}
    //                                 <div className='ms-loyalty-signup__marketing-consents--section'>
    //                                     {clubPlusMarketingConsentAttributes &&
    //                                         renderMarketingConsentAttributes(clubPlusMarketingConsentAttributes)}
    //                                 </div>
    //                             </div>
    //                             <p>{updatePreferenceText}</p>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 {props.signInLink}
    //             </>
    //         );
    //     }
    //     return;
    // };
    // Render checkboxes for marketing consent attributes
    // const renderMarketingConsentAttributes = (marketingConsentAttributes: ISimpleMarketingConsentAttributesData[]) => {
    //     return marketingConsentAttributes.map(attr => {
    //         const { attributeLabel, attributeName } = attr;
    //         const filteredInputCheck = inputCheck.find(attr2 => attr2.Name === attributeName && attr2.BooleanValue);
    //         if(filteredInputCheck){
    //             return (
    //                 <span key={attributeLabel} className='checkbox-section'>
    //                     <input
    //                         type='checkbox'
    //                         aria-checked='true'
    //                         checked={filteredInputCheck ? filteredInputCheck.BooleanValue : false}
    //                         id={attributeName}
    //                         name={attributeName}
    //                         onChange={handleMarketingConsent}
    //                     />
    //                     <label htmlFor={attributeName}>{attributeLabel}</label>
    //                 </span>
    //             );
    //         }else{
    //             return(
    //                 <span key={attributeLabel} className='checkbox-section'>
    //                     <input
    //                         type='checkbox'
    //                         aria-checked='true'
    //                         id={attributeName}
    //                         name={attributeName}
    //                         onChange={handleMarketingConsent}
    //                     />
    //                     <label htmlFor={attributeName}>{attributeLabel}</label>
    //                 </span>
    //             )
    //         }
    //     });
    // };
    // Render date of birth field and display error message if occurs
    const renderDateOfBirthField = () => {
        // const { dateOfBirthLabel } = props.resources;
        const queryTier = props.context.request.query?.tier.toLowerCase();
        return day && day.AttributeValue?.StringValue && month && month.AttributeValue?.StringValue && year && year.AttributeValue?.StringValue ? (
            <div className='loyalty-signup-section__input-holder user-data-field'>
                <form>
                    {queryTier?.toLowerCase() !== 'club' ? <label className='clubplus-label'>Tell us your birthday - we’d love to send you a special treat</label> :
                    <label className='club-label'>Date of birth</label>}
                    {/* <MaskInput showMask={false} maskString={maskString} mask={mask} onChange={updateDOB} value={`${dateOfBirth.AttributeValue?.StringValue}`}/> */}
                    <input placeholder='DD/MM/YYYY' onChange={updateDOB} id='loyalty-signup-dob' onKeyPress={e => {
                        handleMask(e, '99/99/9999');
                        updateDOB(e);
                    }} value={dateOfBirth.AttributeValue?.StringValue} />
                    {/* slot will be rendered for dob description text */}
                    {dateOfBirthText && dateOfBirthText}
                </form>
                {_invalidDobErrorMsg(
                    displayNotification,
                    error,
                    dateError,
                    isValidDob,
                    overEighteen,
                    props.resources,
                    isYearOutOfRange,
                    minYear,
                    maxYear
                )}
            </div>
        ): (
            <div className='loyalty-signup-section__input-holder user-data-field'>
                <form>
                {queryTier?.toLowerCase() !== 'club' ? <label className='clubplus-label'>Tell us your birthday - we’d love to send you a special treat</label> :
                    <label className='club-label'>Date of birth</label>}
                    {/* <MaskInput showMask={false} maskString={maskString} mask={mask} onChange={updateDOB} /> */}
                    <input placeholder='DD/MM/YYYY' onChange={updateDOB} />
                    {/* slot will be rendered for dob description text */}
                    {dateOfBirthText && dateOfBirthText}
                </form>
                {_invalidDobErrorMsg(
                    displayNotification,
                    error,
                    dateError,
                    isValidDob,
                    overEighteen,
                    props.resources,
                    isYearOutOfRange,
                    minYear,
                    maxYear
                )}
            </div>
        );
    };
    // Render local store select element
    const renderLocalStoreField = () => {
        // const { storeLabel } = props.resources;
        return (
            <div className='loyalty-signup-section__input-holder'>
                <div className='select-holder'>
                    <select name='store' onChange={updateLocalStore} id='loyalty-store-selector'>
                        {renderLocalStores()}
                    </select>
                </div>
            </div>
        );
    };
    // Render mobile field
    const renderMobileField = () => {
        const { mobileLabel } = props.resources;
        return mobileNumber && mobileNumber.AttributeValue?.StringValue ? (
            <div className='loyalty-signup-section__input-holder'>
                {/* <label>{mobileLabel}</label> */}
                <input
                    type='number'
                    onChange={handleMobileNumber}
                    aria-valuemax={12}
                    aria-valuemin={11}
                    aria-valuenow={0}
                    name='mobile'
                    placeholder={mobileLabel}
                    {...patternAttribute}
                    value={mobileNumber.AttributeValue?.StringValue}
                    className='user-data-field'
                />
            </div>
        ): (
            <div className='loyalty-signup-section__input-holder'>
                {/* <label>{mobileLabel}</label> */}
                <input
                    type='number'
                    onChange={handleMobileNumber}
                    aria-valuemax={12}
                    aria-valuemin={11}
                    aria-valuenow={0}
                    name='mobile'
                    placeholder={mobileLabel}
                    {...patternAttribute}
                    className='user-data-field'
                />
            </div>
        );
    };
    // Render select element for given attribute
    const renderSelectElement = (
        label: string,
        onChangeHandler: React.ChangeEventHandler<HTMLSelectElement>,
        dropdownLabel: string,
        attribute: string
    ) => {
        return title && title.AttributeValue?.StringValue ? (
            <div className='loyalty-signup-section__input-holder'>
                <div className='select-holder'>
                    <select name={attribute} onChange={onChangeHandler} className='user-data-field'>
                        <option aria-selected='true' value=''>
                            {title.AttributeValue?.StringValue}
                        </option>
                        {renderDropDownOptionsForAttribute(attribute)}
                    </select>
                </div>
            </div>
        ) : (
            <div className='loyalty-signup-section__input-holder'>
                <div className='select-holder'>
                    <select name={attribute} onChange={onChangeHandler} className='user-data-field'>
                        <option aria-selected='true' value=''>Title*</option>
                        {renderDropDownOptionsForAttribute(attribute)}
                    </select>
                </div>
            </div>
        );
    };

    const handlePromoCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPromoCode(e.currentTarget.value);
    };
    const renderPromoCodeField = () => {
        const {
            resources: { promoCodeLabel }
        } = props;
        // const cardNumber = props.data.loyaltyCard.result?.CardNumber;
        // if (cardNumber || (!cardNumber && query?.tier?.toLowerCase() === 'club-plus')) {
        return (
            <div className='loyalty-signup-section__input-holder promo-code'>
                <p>We'll send your member card number to your email address after payment - this may take up to an hour to show in your inbox (remember to check your spam folder)</p>
                <input id='dobbies-loyalty-promocode' type='text' placeholder={promoCodeLabel} onChange={handlePromoCodeChange} value={promoCode}/>
            </div>
        );
        // }
        // return;
    };

    // Render Loyalty terms and conditions section with Action button
    const renderLoyaltyTermsAndConditionsSection = () => {
        // const { joinLoyaltyButtonText } = props.resources;
        return (
            <div className='loyalty-signup-section'>
                <div className='term-condition'>
                    <div className='term-condition__title'>Terms and conditions</div>
                    <div className='term-condition__text'>
                        <p>
                        {query?.tier === 'club' ? 'By joining Dobbies Club, you will get access to exclusive member offers and benefits. It is a condition of joining Club that you agree with our' :'By joining Dobbies Club Plus, you will get access to exclusive member offers and benefits. It is a condition of joining Club Plus that you agree with our'}
                        <a href='/club-terms-and-conditions' target="_blank">terms and conditions</a>
                        </p>
                    </div>
                </div>
                <div className='loyalty-signup-section__checkbox-holder'>
                    <input id='step-one-terms-check' onChange={handleTermsCheck} aria-checked='mixed' type='checkbox' name='agree' className='checkbox' />
                    {_renderLoyaltyTermsLink()}
                </div>
                {/* To handle click functionality overriding the loyalty sign up button */}
                {/* {
                    <Button className='ms-loyalty-signup__btn' disabled={disabled} onClick={updateAttributes}>
                        {joinLoyaltyButtonText}
                    </Button>
                } */}
            </div>
        );
    };

    const addProductToCart = async () => {
        // get product from data that we want to add into cart.

        // VSI CUSTOMIZATION - START
        const context = props.context.actionContext;
        // props.props.context.request.channel!.RecordId

        // Clear cart on page load
        const cartState = await getCartState(props.context.actionContext);

        const lineItemIdsToRemove = [];
        let productToAdd: ISelectedProduct | null;

        const activeCart = cartState.cart;
        for (const activeCartLine of activeCart.CartLines || []) {
            lineItemIdsToRemove.push(activeCartLine.LineId!);
        }

        if (lineItemIdsToRemove.length > 0) {
            try {
                await cartState.removeCartLines({ cartLineIds: lineItemIdsToRemove });
            } catch (error) {
                throw error;
            }
        }

        if (!props.context.request.query?.tier) {
            return;
        }

        const tier = props.context.request.query.tier.toLowerCase();

        if (tier === TierType.ClubPremium) {
            const variantInput = new SelectedVariantInput(clubPremiumTierId!, props.context.request.channel!.RecordId);
            const newProduct = await getSelectedVariant(variantInput, context);

            productToAdd = newProduct;
        } else if (tier === TierType.ClubPlusFreeTrial) {
            const variantInput = new SelectedVariantInput(clubPlusTrialTierId!, props.context.request.channel!.RecordId);
            const newProduct = await getSelectedVariant(variantInput, context);

            productToAdd = newProduct;
        } else if (tier === 'club-plus-bolton') {
            const loyaltGroups = props.data.loyaltyCard.result?.LoyaltyGroups![0];
            if (loyaltGroups) {
                const highestActiveLoyaltyCardTier = loyaltGroups.HighestActiveLoyaltyCardTier;
                const activatedTier = loyaltGroups.LoyaltyCardTiers!.find(card => card.RecordId === highestActiveLoyaltyCardTier);
                console.log('activeTier', activatedTier);
                if (activatedTier?.TierId === 'Club Plus') {
                    const variantInput = new SelectedVariantInput(clubPlusBoltOnId!, props.context.request.channel!.RecordId);
                    const newProduct = await getSelectedVariant(variantInput, context);
                    productToAdd = newProduct;
                } else if (
                    activatedTier?.TierId === 'Club Plus Free Trial' &&
                    props.config.allowBoltonsPurcharseForClubPlusFreeTrial
                ) {
                    const variantInput = new SelectedVariantInput(clubPlusBoltOnId!, props.context.request.channel!.RecordId);
                    const newProduct = await getSelectedVariant(variantInput, context);
                    productToAdd = newProduct;
                } else {
                    window.location.assign('/loyalty');
                }
            }
        } else {
            const variantInput = new SelectedVariantInput(clubPlusTierId!, props.context.request.channel!.RecordId);
            const newProduct = await getSelectedVariant(variantInput, context);

            productToAdd = newProduct;
        }

        // if cartLines is empty add product to cart
        if (cartState.cart.CartLines && cartState.cart.CartLines.length === 0) {
            await cartState.addProductToCart({ product: productToAdd!, count: 1, enableStockCheck: false });
            const newCartState = await getCartState(props.context.actionContext);
            setCurrCartState(newCartState);
            // After adding product to cart redirects user to checkout page
            // setItemAdded(true);
        }
        // const checkoutLink = Msdyn365.getUrlSync('checkout', props.props.context.actionContext) || '';

        // if (tier === TierType.ClubPremium) {
        //     window.location.assign(`${checkoutLink}?tier=club-premium`);
        // } else if (tier === TierType.ClubPlus) {
        //     window.location.assign(`${checkoutLink}?tier=club-plus`);
        // } else if (tier === 'club-plus-bolton') {
        //     window.location.assign(`${checkoutLink}?tier=club-plus-bolton`);
        // } else {
        //     window.location.assign(`${checkoutLink}`);
        // }
    };



    const matchTiersAndAddProductToCart = () => {
        const tier = props.context.request.query?.tier.toLowerCase();
        const loyaltyGroups = props.data.loyaltyCard.result?.LoyaltyGroups;
        if (tier && tier.toLowerCase() !== clubPlusText?.toLowerCase()) {
            // !itemAdded && addProductToCart();
            addProductToCart();
            // TODO: if tier is expired what to do
        } else if (
            tier &&
            tier.toLowerCase() === clubPlusText?.toLowerCase() &&
            loyaltyGroups &&
            loyaltyGroups.length &&
            loyaltyGroups[0].LoyaltyCardTiers &&
            loyaltyGroups[0].LoyaltyCardTiers.length
        ) {
            const validToDate = loyaltyGroups && loyaltyGroups[0].LoyaltyCardTiers[0].ValidTo;
            const endDate = new Date(validToDate ?? '');
            const today = new Date();
            const timeDifference = endDate.getTime() - today.getTime() + 24 * 60 * 60 * 1000;
            const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            const daysLimit = props.context?.app?.config?.clubPlusRenewalDays || 30;
            if (remainingDays <= daysLimit) {
                // !itemAdded && addProductToCart();
                addProductToCart();
            } else {
                // const loyaltyLink = props.context?.app?.config?.loyaltyLink;
                // window.location.assign(loyaltyLink);
            }
        } else {
            // redirects user to loyalty page (so he can view his points)
            // const loyaltyLink = props.context?.app?.config?.loyaltyLink;
            // window.location.assign(loyaltyLink);
        }
    }

    const validateInputs = () => {
        if(!Msdyn365.msdyn365Commerce.isBrowser || !document) {
            return;
        }
        const inputElements = document.getElementsByClassName('user-data-field');
        if (inputElements && inputElements.length) {
            for (let i = 0; i < inputElements.length; i++) {
                if (inputElements[i] instanceof HTMLSelectElement) {
                    const inputElem = inputElements[i] as HTMLSelectElement;
                    if ((!inputElem.value && !title?.AttributeValue?.StringValue) || inputElem.value === 'Not stated' || title?.AttributeValue?.StringValue === 'Not stated' || inputElem.value === 'Title*' || title?.AttributeValue?.StringValue === 'Title*') {
                        return false;
                    }
                } else if (inputElements[i] instanceof HTMLInputElement) {
                    const inputElem = inputElements[i] as HTMLInputElement;
                    if (!inputElem.value) {
                        return false;
                    }
                } else if (inputElements[i] instanceof HTMLDivElement) {
                    const inputElem = inputElements[i] as HTMLDivElement;
                    const inputElement = inputElem.querySelector('input');
                    const queryTier = props.context.request.query?.tier?.toLowerCase();
                    
                    if (inputElement instanceof HTMLInputElement) {
                        const divInput = inputElement as HTMLInputElement;
                        if (queryTier === 'club' && !divInput.value) {
                            if (error) {
                                SetError('');
                            }
                            if (dateError) {
                                SetDateError('');
                            }
                            continue;
                        }
                        if (!divInput.value || divInput.value.includes('MM/')) {
                            return false;
                        }
                        try {
                            if(!validateDOB(divInput.value)) {
                                SetError('DOB Error');
                                return false;
                            }
                        } catch (e) {
                            console.log('DOB error', e);
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }

    const _getSlot = (slotName: string): React.ReactNode[] | null => {
        const { slots } = props;
        return (slots && slots[slotName] && slots[slotName].length && slots[slotName]) || null;
    }
    const validateStepOneInputs = () => {
        if (Msdyn365.msdyn365Commerce.isBrowser && window) {
            const allAddressInputs = document.getElementsByClassName('msc-address-form__input-text');
            const addressValues: string[] = [];
            if (allAddressInputs && allAddressInputs.length) {
                for (let i = 0; i < allAddressInputs.length; i++) {
                    if (allAddressInputs[i] instanceof HTMLInputElement) {
                        const inputElem = allAddressInputs[i] as HTMLInputElement;
                        if (!inputElem.value) {
                            return false;
                        }
                        addressValues.push(inputElem.value);
                    }
                }
            }
            if (!tAndRChecked) {
                return false;
            }
            if (addressValues.length === allAddressInputs.length) {
                const storeSelectorElem = document.getElementById('loyalty-store-selector') as HTMLSelectElement;
                if (storeSelectorElem && storeSelectorElem.value && storeSelectorElem.value.toLowerCase() !== 'local store *') {
                    return true;
                }
                if (localStore && localStore.AttributeValue?.StringValue && localStore.AttributeValue?.StringValue !== 'local store *' ) {
                    return true;
                }
            }
            return false;
        }
        return false
    };

    const capitalizeFirstLetter = (str: string) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    // Render full view for loyalty sign up page
    const renderLoyaltySignUpView = () => {
        // const { titleLabel, pleaseSelectText, genderLabel } = props.resources;
        const { titleLabel, pleaseSelectText } = props.resources;
        // const { nonClubMemberStatement, memberStatement } = props.config;
        // const { titleAttribute, genderAttribute } = props.config;
        const { titleAttribute } = props.config;
        const CardNumber = props.data.loyaltyCard.result?.CardNumber;
        let formattedPrice: number | string | undefined;
    /* VSI Customization - START - 24/08/21 */
    
        let price = currCartState?.cart.CartLines && currCartState?.cart.CartLines.length ? currCartState?.cart.CartLines[0].Price : 0;
        if (price === 0) {
            formattedPrice = '£0.00';
        } else {
            formattedPrice = price && props.context.cultureFormatter.formatCurrency(price, props.context.request.channel?.Currency);
        }
        // const tierID = tierId?.toLowerCase();
        if (CardNumber && currStep === 0) {
            // setCurrStep(1);
        }
        const tier = props.context.request.query?.tier.toLowerCase();
        
        let nextButtonText = '';
        if (currStep === 0 && tier === TierType.Club) {
            nextButtonText = 'Continue to final step';
        } else if (currStep === 1 && (tier === TierType.ClubPlus || tier === TierType.ClubPremium || tier === TierType.ClubPlusFreeTrial)) {
            nextButtonText = 'Continue to final step';
        } else if (currStep === 1) {
            nextButtonText = `Join ${capitalizeFirstLetter('club')}`;
        } else if (currStep === 2) {
            try {
                let tierText = '';
                const tierTextSplitted = tier?.split('-');
                if (tierTextSplitted && tierTextSplitted.length > 1) {
                    for (const splittedTxt of tierTextSplitted) {
                        tierText = tierText.concat(` ${capitalizeFirstLetter(splittedTxt)}`);
                    }
                }
                nextButtonText = `Join ${tierText}`;
            } catch (e) {
                console.log('Error splitting tier', e);
                nextButtonText = 'Join Club Plus Tiers Membership';
            }
        } else {
            nextButtonText = 'Next';
        }
        let stepClassName = '';
        if (currStep === 0) {
            stepClassName = 'step-one';
        } else if (currStep === 1) {
            stepClassName = 'step-two';
        } else if (currStep === 2) {
            stepClassName = 'step-three';
        }
        let billingModule = null;
        try {
            billingModule  = _getSlot('checkoutBillingAddress');
        } catch (e) {
            console.log('Error getting Billing Module', e);
        }
        console.log('Billing Module', billingModule);
        const inputsAreValid = validateInputs();
        if (inputsAreValid !== undefined && showBtnDisabled !== (!inputsAreValid) && currStep == 0) {
            setShowButtonDisabled(!inputsAreValid);
        }
        if (!disabled && !validateStepOneInputs() && currStep === 1) {
            setDisabled(true);
        } else if (validateStepOneInputs() && disabled && currStep === 1) {
            setDisabled(false);
        }

        const shouldBtnBeDisabledVar = (currStep === 0 && showBtnDisabled) || (currStep === 1 && disabled) || (currStep === 2 && !props.data.inputsValidations.result?.areAllFieldsValid);
        
        if (shouldBtnBeDisabled !== shouldBtnBeDisabledVar) {
            setShouldBtnBeDisabled(shouldBtnBeDisabledVar);
        }

        return (
            <div className={dynamicClass}>
                <div className={currStep === 0 ? 'loyalty-signup-custom-header': 'loyalty-signup-custom-header d-none'}>
                    <h2>Join Now</h2>
                    <p className={query?.tier === 'club' ? 'club':'club-plus'}>You’re just a few simple steps away from becoming a {query?.tier === 'club' ? 'Club member!':'Club Plus member!'}</p>
                </div>
                {query?.tier === 'club' ? <ul className={`loyalty-signup-steps ${stepClassName}`}>
                    <li className='one' onClick={() => {
                        iconOneClicked();
                    }}>
                        <div>
                            <img className='not-active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDa9zE" alt="" />
                            <img className='active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDahnw" alt="" />
                        </div>
                        <p>
                            Step 1: <br></br> Personal details
                        </p>
                    </li>
                    <li className='two' onClick={() => {
                        iconTwoClicked();
                    }}>
                        <div>
                            <img className='not-active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDahnn" alt="" />
                            <img className='active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDahnq" alt="" />
                        </div>
                        <p>
                            Step 2:<br></br> Address
                        </p>
                    </li>
                </ul> : <ul className={`loyalty-signup-steps ${stepClassName}`}>
                    <li className='one' onClick={() => {
                        iconOneClicked();
                    }}>
                        <div>
                        <img className='not-active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDa9zE" alt="" />
                        <img className='active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDahnw" alt="" />
                        </div>
                        <p>
                            Step 1: <br></br> Personal details
                        </p>
                    </li>
                    <li className='two' onClick={() => {
                        iconTwoClicked();
                    }}>
                        <div>
                            <img className='not-active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDahnk" alt="" />
                            <img className='active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDahnt" alt="" />
                        </div>
                        <p>
                            Step 2:<br></br> Address
                        </p>
                    </li>
                    <li className='three' onClick={() => {
                        iconThreeClicked();
                    }}>
                        <div>
                            <img className='not-active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDahnn" alt="" />
                            <img className='active' src="https://images-eu-prod.cms.commerce.dynamics.com/cms/api/ctdwmwnctb/imageFileData/MDahnq" alt="" />
                        </div>
                        <p>
                            Step 3:<br></br> Payment
                        </p>
                    </li>
                </ul>}
                <div className='loyalty-signup-custom-container'>
                    {<>
                        {currStep === 0 && <div>
                            {renderSelectElement(titleLabel, updateTitle, pleaseSelectText, titleAttribute)}
                            {/* {`First name: ${props.data.customerInformation.result?.FirstName}`}
                            {`Last name: ${props.data.customerInformation.result?.LastName}`} */}
                            {renderFirstAndLastName(props)}
                            <p className='loyalty-signup-section__personal-information--email'>{`Email: ${props.data.customerInformation.result?.Email}`}</p>
                            {renderMobileField()}
                            {renderDateOfBirthField()}
                        </div>}
                        {currStep === 1 && <div>
                            {props.slots.address}
                            {renderLocalStoreField()}
                            {renderLoyaltyTermsAndConditionsSection()}
                        </div>}
                        {currStep === 2 && 
                        <div className='club-payment'>
                                {/* <div className='billing-address-checkboxes'>
                                    <p>Use the same address for my billing address:</p>
                                    <div className='checkbox-list'>
                                        <input onChange={doUseSameBillingAddressAsShipping} type='checkbox' name='usesameaddress' id='usesameaddressyes' className='checkbox' /> Yes
                                        <input onChange={doNotUseSameBillingAddressAsShipping} type='checkbox' name='usesameaddress' id='usesameaddressno' className='checkbox' /> No
                                    </div>
                                </div> */}
                                {billingModule}
                                {renderPromoCodeField()}

                                <div className='order-summary'>
                                    <p>Order Summary</p>
                                    <ul>
                                        <li>
                                            <span>Club Plus</span> {formattedPrice}
                                        </li>
                                        <li>
                                            <span>Total</span> {formattedPrice}
                                        </li>
                                    </ul>
                                </div>

                                {props.slots.checkoutSectionContainer && props.slots.checkoutSectionContainer[0]}
                                
                            </div>}
                        <Button id='loyalty-next-btn' className={shouldBtnBeDisabled ? 'loyalty-btn ms-loyalty-signup__terms disabled' : 'loyalty-btn ms-loyalty-signup__terms'} disabled={shouldBtnBeDisabled} onClick={() => {
                            if (disabled && currStep === 1) {
                                return;
                            }
                            if (currStep === 0) {
                                if (validateInputs()) {
                                    setShowButtonDisabled(false);
                                    const phoneNum = mobileNumber.AttributeValue?.StringValue;
                                    props.context.actionContext.requestContext.cookies.set('loyalty_singup_phone', phoneNum);
                                    setCurrStep(currStep + 1);
                                    props.context.actionContext.requestContext.cookies.set('step_1_clicked_next', 'true');
                                }
                            } else if (currStep === 1) {
                                updateAttributes();
                            } else if (currStep === 2) {
                                placeLoyaltyOrder();
                            }
                        }}>
                            {nextButtonText}
                        </Button> 
                        </>
                    }
                    {/* <Module {...LoyaltySignUp}>
                        <div className='ms-content-block'>
                            <div className='ms-content-block__details'>
                                {displayHeading(props)}
                                <div className='ms-content-block__text'>
                                    {tierID === 'club' ? <p>{memberStatement} </p> : <p>{nonClubMemberStatement} </p>}
                                </div>
                            </div>
                        </div>
                        <div className='loyalty-signup-section'>
                            {renderMainHeading(props)}
                            {!CardNumber && (
                                <>
                                    {renderSelectElement(titleLabel, updateTitle, pleaseSelectText, titleAttribute)}
                                    {titleNotSelectedErrorMsg()}
                                    {renderFirstAndLastName(props)}
                                    {renderMobileField()}
                                    {renderDateOfBirthField()}
                                </>
                            )}
                            {props.slots.address}
                            {addressError !== '' && <Node className='localstore-not-selected-error'>{addressError}</Node>}
                            {!CardNumber && (
                                <>
                                    {renderSelectElement(genderLabel, updateGenderValue, pleaseSelectText, genderAttribute)}
                                    {_genderNotSelectedErrorMsg()}
                                    {renderLocalStoreField()}
                                </>
                            )}
                            {renderPromoCodeField()}
                        </div>
                        {renderMarketingConsentSection()}
                        {renderLoyaltyTermsAndConditionsSection()}
                    </Module> */}
                </div>
            </div>
        );
    };
    // Due to use of useState hooks inside this function need to disable tslint
    // tslint:disable-next-line: max-func-body-length
    const renderJSX = (): JSX.Element => {
        const { redirectingLoaderText, authenticationMessage } = props.resources;
        let { clubFreeTierText, clubPlusTierText } = props.config;
        clubFreeTierText = clubFreeTierText?.toLowerCase();
        clubPlusTierText = clubPlusTierText?.toLowerCase();
        const tierID = tierId?.toLowerCase();
        const queryParam = query?.tier?.toLowerCase();
        const CardNumber = props.data.loyaltyCard.result?.CardNumber;
        if (!props.context.request.user.isAuthenticated) {
            return <RenderErrorMessageWithLoader message={authenticationMessage} />;
        } else if (CardNumber && tierID === clubFreeTierText && queryParam === 'club-free') {
            return <RenderErrorMessageWithLoader message={redirectingLoaderText} />;
        } else if (CardNumber && tierID === clubPlusTierText && (queryParam === 'club-plus' || queryParam === 'club-plus-trial')) {
            return <RenderErrorMessageWithLoader message={redirectingLoaderText} />;
        } else if (CardNumber && tierID === clubPlusTierText && queryParam === 'club-free') {
            return <RenderErrorMessageWithLoader message={redirectingLoaderText} />;
        } else {
            return <>{renderLoyaltySignUpView()}</>;
        }
    };
    // Here's the main rendering
    return <>{renderJSX()}</>;
};
// Custom hook to get custom address count
const useGetAddressesCount = (props: ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>) => {
    const [addressCount, setAddressCount] = useState<Address[] | undefined>([]);
    useEffect(() => {
        setAddressCount(props.data.getCustomerAddress.result?.addresses);
    });
    return addressCount;
};

// Provide the TierId of user's loyalty
const getTierId = (loyaltyGroup: LoyaltyGroup | undefined) => {
    // highestLoyaltCardTier
    const highestActiveLoyaltyCardTier = loyaltyGroup && loyaltyGroup.HighestActiveLoyaltyCardTier;
    const loyaltyCardTiers = loyaltyGroup && loyaltyGroup.LoyaltyCardTiers;
    if (loyaltyCardTiers && loyaltyCardTiers?.length > 0) {
        for (const [_, loyaltyCardTier] of loyaltyCardTiers.entries()) {
            if (loyaltyCardTier.RecordId === highestActiveLoyaltyCardTier) {
                return loyaltyCardTier.TierId;
            }
        }
    }
    return;
};

// const renderMainHeading = (props: ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>) => {
//     if (!props.data.loyaltyCard.result?.CardNumber) {
//         return (
//             <>
//                 {renderHeading(props.config.memberHeading)}
//                 <div className='loyalty-signup-section__title'>
//                     <h2 className='ms-loyalty-signup__heading'>{props.resources.additionalDetailsLabel}</h2>
//                 </div>
//             </>
//         );
//     }
//     return;
// };
// this will return attribute which we need to for club plus members like (direct debit, promo code).
const getCustomAttribute = (
    props: ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>,
    attribute: string,
    value: string
): CustomerAttribute => {
    // const { directDebitAttribute, directDebitAttributeValue} = props.config;
    const defaultAttribute = props.data.attributeDefinitions.result?.find(attr => attr.Name?.toLowerCase() === attribute?.toLowerCase());
    return {
        ['AttributeValue']: {
            // @ts-ignore
            '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CommercePropertyValue',
            StringValue: value
        },
        ['@odata.type']: '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CustomerAttribute',
        ['ExtensionProperties@odata.type']: '#Collection(Microsoft.Dynamics.Commerce.Runtime.DataModel.CommerceProperty)',
        ['NameTranslations@odata.type']: '#Collection(Microsoft.Dynamics.Commerce.Runtime.DataModel.TextValueTranslation)',
        ['NameTranslations']: [],
        ['DataTypeValue']: defaultAttribute && defaultAttribute.DataTypeValue,
        ['KeyName']: defaultAttribute && defaultAttribute.Name,
        ['Name']: defaultAttribute && defaultAttribute.Name,
        ['RecordId']: defaultAttribute && defaultAttribute.RecordId,
        ['ExtensionProperties']: []
    };
};
// This function will render generic headings
// const renderHeading = (heading: (IHeadingData & IHeadingData) | undefined) => {
//     return heading?.text && <Msdyn365.Text className='ms-loyalty-signup__heading' tag={heading.tag} text={heading.text} />;
// };
// Render Customer's first and last name
const renderFirstAndLastName = (props: ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>) => {
    const {
        customerInformation: { result }
    } = props.data;
    return (
        <div className='loyalty-signup-section__personal-information'>
            <div className='loyalty-signup-section__personal-information--first-name'>
                <p>First name: {result?.FirstName}</p>
            </div>
            <div className='loyalty-signup-section__personal-information--last-name'>
                <p>Last name: {result?.LastName}</p>
            </div>
        </div>
    );
};
// Function for setting attribute default value
const setAttrDefaultValues = (attribute: CustomerAttribute) => {
    return {
        // @ts-ignore
        '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CustomerAttribute',
        Attribute: undefined,
        DataTypeValue: attribute.DataTypeValue,
        KeyName: attribute.Name,
        Name: attribute.Name,
        RecordId: attribute.RecordId,
        Units: undefined,
        AttributeValue: {
            // @ts-ignore
            '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CommercePropertyValue',
            StringValue: attribute.DataTypeValue === 5 ? '' : null,
            BooleanValue: attribute.DataTypeValue === 6 ? false : null
        },
        'ExtensionProperties@odata.type': '#Collection(Microsoft.Dynamics.Commerce.Runtime.DataModel.CommerceProperty)',
        ExtensionProperties: [],
        'NameTranslations@odata.type': '#Collection(Microsoft.Dynamics.Commerce.Runtime.DataModel.TextValueTranslation)',
        NameTranslations: []
    };
};

const setAttributeValue = (value: string | boolean, attribute: CustomerAttribute, isBoolean: boolean) => {
    return {
        ['AttributeValue']: {
            // @ts-ignore
            '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CommercePropertyValue',
            IntegerValue: null,
            BooleanValue: isBoolean ? value : null,
            StringValue: isBoolean ? null : value,
            DecimalValue: null
        },
        ['@odata.type']: '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CustomerAttribute',
        ['ExtensionProperties@odata.type']: '#Collection(Microsoft.Dynamics.Commerce.Runtime.DataModel.CommerceProperty)',
        ['NameTranslations@odata.type']: '#Collection(Microsoft.Dynamics.Commerce.Runtime.DataModel.TextValueTranslation)',
        ['NameTranslations']: [],
        ['DataTypeValue']: (attribute && attribute.DataTypeValue) || '',
        ['KeyName']: (attribute && attribute.Name) || '',
        ['Name']: (attribute && attribute.Name) || '',
        ['RecordId']: (attribute && attribute.RecordId) || '',
        ['ExtensionProperties']: []
    };
};
// Will render generic loader with given message
const RenderErrorMessageWithLoader: React.FC<{ message: string }> = ({ message }) => {
    return (
        <div className='loading-message-container'>
            <div className='loading-message-container__innerbox'>
                <Waiting />
                <span>{message}</span>
            </div>
        </div>
    );
};
// Redirects the user based on certain criteria defined inside function
const redirectUserIfTierExist = (props: ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>, tierId: string | undefined) => {
    const { clubFreeTierText, clubPlusTierText } = props.config;
    const {
        data: { loyaltyCard },
        context: {
            request: { query }
        }
    } = props;
    // -1 If user is already dobbies club free member and wants to enroll for it again
    // redirects him to loyalty page
    if (
        loyaltyCard.result?.CardNumber &&
        tierId?.toLowerCase() === clubFreeTierText?.toLowerCase() &&
        query?.tier?.toLowerCase() === 'club-free'
    ) {
        // redirects him to loyalty page.
        // window.location.assign(Msdyn365.getUrlSync('/loyalty', props.context.actionContext) || '');
        window.location.assign('/loyalty');
        return;
    }
    /* -2 If user is already dobbies club plus member and wants to enroll for it again redirects him to loyalty page */
    if (
        loyaltyCard.result?.CardNumber &&
        tierId?.toLowerCase() === clubPlusTierText?.toLowerCase() &&
        query?.tier?.toLowerCase() === 'club-plus'
    ) {
        // redirects him to loyalty page.
        // window.location.assign(Msdyn365.getUrlSync('/loyalty', props.context.actionContext) || '');
        window.location.assign('/loyalty');
        return;
    }

    /* -2 If user is already dobbies club plus member and wants to enroll for it again redirects him to loyalty page */
    if (
        loyaltyCard.result?.CardNumber &&
        tierId?.toLowerCase() === clubPlusTierText?.toLowerCase() &&
        query?.tier?.toLowerCase() === 'club-plus'
    ) {
        // redirects him to loyalty page.
        // window.location.assign(Msdyn365.getUrlSync('/loyalty', props.context.actionContext) || '');
        window.location.assign('/loyalty');
        return;
    }
    /* -3 If user is club plus member now he mistakenly wants to enroll in free tier redirects him to loyalty page */
    if (
        loyaltyCard.result?.CardNumber &&
        tierId?.toLowerCase() === clubPlusTierText?.toLowerCase() &&
        query?.tier?.toLowerCase() === 'club-free'
    ) {
        // redirects him to loyalty page.
        // window.location.assign(Msdyn365.getUrlSync('/loyalty', props.context.actionContext) || '');
        window.location.assign('/loyalty');
        return;
    }

    /* -4 If user is already dobbies club plus member and wants to enroll in dobbies free club trial redirects him to loyalty page */
    if (
        loyaltyCard.result?.CardNumber &&
        tierId?.toLowerCase() === clubPlusTierText?.toLowerCase() &&
        query?.tier?.toLowerCase() === 'club-plus'
    ) {
        // redirects him to loyalty page.
        // window.location.assign(Msdyn365.getUrlSync('/loyalty', props.context.actionContext) || '');
        window.location.assign('/loyalty');
        return;
    }
};

const _invalidDobErrorMsg = (
    displayNotification: boolean,
    error: string,
    dateError: string,
    isValidDob: Boolean,
    overEighteen: boolean,
    resources: ILoyaltySignUpResources,
    isYearOutOfRange: boolean,
    minYear: number,
    maxYear: number
) => {
    // const { validDateErrorText, ageRestrictionError, validYearErrorText } = resources;
    // const { validDateErrorText } = resources;
    // const yearRangeErrorText = validYearErrorText.replace('{minYear}', minYear.toString()).replace('{maxYear}', maxYear.toString());
    // if ((error !== '' || dateError !== '') && displayNotification && !isYearOutOfRange) {
    if ((error !== '' || dateError !== '')) {
        return (
            <Node className='invalid-input-dob-error'>
                {/* {!isValidDob ? validDateErrorText : !overEighteen ? ageRestrictionError : undefined} */}
                {!isValidDob ? 'Please enter a valid date of birth' : undefined}
            </Node>
        );
    }
    // if (error !== '' && isValidDob && isYearOutOfRange) {
    //     return <Node className='loyalty-validation-error'>{yearRangeErrorText}</Node>;
    // }
    return;
};

// const _renderTermsAndConditionsText = (
//     termsAndConditionLink: ITermsAndConditionsLinkData,
//     termsAndConditionsText: string,
//     linkClass: string,
//     textClass: string
// ) => {
//     const termsAndConditionLinkData: Msdyn365.ILinksData = {
//         ariaLabel: termsAndConditionLink.ariaLabel || undefined,
//         className: linkClass,
//         linkText: termsAndConditionLink.linkText,
//         linkUrl: termsAndConditionLink.linkUrl && termsAndConditionLink.linkUrl.destinationUrl
//     };
//     return (
//         <Node tag='p' className={textClass}>
//             {termsAndConditionsText}
//             <Msdyn365.Link link={termsAndConditionLinkData} />
//         </Node>
//     );
// };
// Display main heading on page to differentiate b/w Club and Club Plus page
// const displayHeading = (props: ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>) => {
//     const { joiningClubPlusText, joiningClubText, joiningClubPlusTrialText } = props.resources;
//     const query = props.context.request.query;
//     if (query?.tier?.toLowerCase() === 'club-free') {
//         return <h2 className='ms-content-block__title'>{joiningClubText}</h2>;
//     } else if (query?.tier?.toLowerCase() === 'club-plus-trial') {
//         return <h2 className='ms-content-block__title'>{joiningClubPlusTrialText}</h2>;
//     } else if (query?.tier?.toLowerCase() === 'club-plus') {
//         return <h2 className='ms-content-block__title'>{joiningClubPlusText}</h2>;
//     } else {
//         return <h2 className='ms-content-block__title'>{joiningClubText}</h2>;
//     }
// };
// Will update state after getting maxYear and minYear from values coming from D365 for Year Attribute
// tslint:disable-next-line: max-line-length
const setMinAndMaxYear = (
    props: ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>,
    SetMinYear: React.Dispatch<React.SetStateAction<number>>,
    minYear: number,
    SetMaxYear: React.Dispatch<React.SetStateAction<number>>,
    maxYear: number
): void => {
    useEffect(() => {
        if (minYear === -1 && maxYear === -1) {
            // const attributes = props.data.attributeDefinitions.result;
            // const yearAttr = attributes?.find(x => x.Name?.toLowerCase() === 'year');
            // let years: number[] | undefined = [];
            // let _minYear;
            // if (yearAttr) {
            //     years = yearAttr.EnumerationDetails?.map(enumeration => {
            //         // tslint:disable-next-line: radix
            //         return parseInt(enumeration.EnumerationValue!);
            //     });
            //     _minYear = years && Math.min.apply(null, years);
            // }
            SetMinYear(1900);
            // Now calculate max year as 18 years back from current date
            const date = new Date();
            const maximumYear = date.getFullYear() - 18;
            SetMaxYear(maximumYear);
        }
    });
};
// Provide dynamic class based on query param for club and club plus
const getDynamicClass = (
    query: Msdyn365.IDictionary<string> | undefined,
    props: React.PropsWithChildren<ILoyaltySignUpViewProps & ILoyaltySignUpProps<ILoyaltySignUpData>>
) => {
    let dynamicClass: string = 'dobbies-club-free';
    let loyaltyTermsLinkText: string = '';
    const queryParam = query && query.tier && query.tier.toLowerCase();
    if (queryParam === 'club-free') {
        dynamicClass = 'dobbies-club-free';
        loyaltyTermsLinkText = props.resources.loyaltyTermsLinkText;
    } else if (queryParam === 'club-plus' || queryParam === 'club-plus-trial') {
        dynamicClass = 'dobbies-club-plus club-signup-bg';
        loyaltyTermsLinkText = props.resources.loyaltyPlusTermsLinkText;
    }
    return { loyaltyTermsLinkText, dynamicClass };
};
export default LoyaltySignUpView;
